/* ==========================================================================
   Beanwatch · Tools
   Zwei Rechner, die tatsächlich rechnen: Koffein über den Tag und
   Wasserhärte. Beide laufen komplett im Browser, ohne Anmeldung. Gerechnet
   wird nur hier; einzig der Koffeinrechner meldet, dass er benutzt wurde
   (messen(), Ereignis für Google Analytics über den Tag Manager). Im Theme
   lädt der Tag Manager erst nach «Alle Cookies akzeptieren»
   (bw-tagmanager.liquid), vorher bleibt das Ereignis im dataLayer der
   Seite und geht nirgends hin.

   Im Theme steht ein Datenblock #bw-tools-texte in der Seite: übersetzte
   Texte, Dezimalzeichen und die Adresse der Rechnerseite. tx() nimmt den
   Text von dort, sonst den deutschen Wortlaut hier; Platzhalter in
   geschweiften Klammern ({mg}, {uhr}) werden ersetzt. Ohne Block bleibt
   alles wie im Prototyp.
   ========================================================================== */

window.BWTools = (function () {
  'use strict';

  const ruhig = window.BW && window.BW.wenigerBewegung;

  // Shopify maskiert übersetzte Texte (&#39; usw.), deshalb einmal
  // zurückwandeln. Texte mit Fettdruck (strong) gehen danach per innerHTML hinein.
  function entschluesseln(w) {
    if (typeof w === 'string') {
      const t = document.createElement('textarea');
      t.innerHTML = w;
      return t.value;
    }
    if (Array.isArray(w)) return w.map(entschluesseln);
    if (w && typeof w === 'object') {
      const o = {};
      Object.keys(w).forEach((k) => { o[k] = entschluesseln(w[k]); });
      return o;
    }
    return w;
  }
  const TEXTE = (function () {
    const el = document.getElementById('bw-tools-texte');
    if (!el) return {};
    try { return entschluesseln(JSON.parse(el.textContent)); } catch (e) { return {}; }
  })();
  function tx(name, deutsch, werte) {
    const s = typeof TEXTE[name] === 'string' && TEXTE[name] !== '' ? TEXTE[name] : deutsch;
    return werte ? s.replace(/\{(\w+)\}/g, (m, k) => (k in werte ? werte[k] : m)) : s;
  }
  // Adresse der Rechnerseite für Teilen und Bild, im Theme die echte.
  const ADRESSE = tx('adresse', 'beanwatch.ch/koffeinrechner');
  const ADRESSE_URL = tx('adresse_url', 'https://beanwatch.ch/koffeinrechner');
  // Dezimalzeichen, im Theme nach Sprache. Der Prototyp zeigt Punkte.
  const zahl1 = (w) => w.toFixed(1).replace('.', tx('dezimal', '.'));

  /* ======================================================================
     Koffeinrechner
     ====================================================================== */

  /* Nach der Espresso-Basis sortiert statt nach Getränkenamen. Wer einen
     Flat White getrunken hat, weiss meist nicht, ob ein oder zwei Shots drin
     waren, aber „doppelter Espresso“ versteht jeder.

     Drei Arten von Einträgen:
       mg            fester Wert pro Portion
       proGramm      Koffein je Gramm Kaffeemehl, fragt die Menge ab
       proHundertMl  Koffein je 100 ml, fragt die Menge ab                */
  const GETRAENKE = [
    {
      name: 'Einfacher Espresso', kurz: 'Espresso', mg: 63,
      liste: 'Einfacher Espresso (als Cappuccino, Latte Macchiato, Cortado oder pur)',
      hinweis: 'ein Shot, egal ob pur oder mit Milch'
    },
    {
      name: 'Doppelter Espresso', kurz: 'Doppelter Espresso', mg: 126,
      liste: 'Doppelter Espresso (als Flat White, Espresso Tonic, Americano oder pur)',
      hinweis: 'zwei Shots, egal ob pur oder mit Milch'
    },
    {
      name: 'Café Crème', kurz: 'Café Crème', mg: 100,
      liste: 'Café Crème (der lange Bezug, in der Schweiz «ein Kaffee»)',
      hinweis: 'länger bezogen als ein Espresso, daher mehr Koffein'
    },
    {
      name: 'Filterkaffee', kurz: 'Filterkaffee', proGramm: 9, standard: 15, einheit: 'g',
      liste: 'Filterkaffee (V60, Chemex, French Press, Filtermaschine)',
      hinweis: 'gerechnet wird mit der Kaffeemenge, nicht mit der Tassengrösse'
    },
    {
      name: 'Cold Brew', kurz: 'Cold Brew', proGramm: 10, standard: 20, einheit: 'g',
      liste: 'Cold Brew (kalt angesetzt, über Nacht gezogen)',
      hinweis: 'lange Extraktion, holt am meisten Koffein heraus'
    },
    {
      name: 'Matcha Latte', kurz: 'Matcha', proGramm: 35, standard: 2, einheit: 'g',
      liste: 'Matcha Latte (nach Matcha-Menge)',
      hinweis: 'ein gehäufter Teelöffel sind etwa 2 g'
    },
    {
      name: 'Decaf Espresso', kurz: 'Decaf', mg: 3,
      liste: 'Decaf Espresso (einfach oder doppelt)',
      hinweis: 'praktisch koffeinfrei, der Unterschied ist hier egal'
    },
    {
      name: 'Decaf Filterkaffee', kurz: 'Decaf Filter', proGramm: 0.3, standard: 15, einheit: 'g',
      liste: 'Decaf Filterkaffee (nach Kaffeemenge)',
      hinweis: 'praktisch koffeinfrei'
    },
    {
      name: 'Schwarztee', kurz: 'Schwarztee', proHundertMl: 19, standard: 250, einheit: 'ml',
      liste: 'Schwarztee (nach Tassengrösse)',
      hinweis: 'zum Vergleich, schwankt stark mit der Ziehzeit'
    },
    {
      name: 'Grüntee', kurz: 'Grüntee', proHundertMl: 12, standard: 250, einheit: 'ml',
      liste: 'Grüntee (nach Tassengrösse)',
      hinweis: 'zum Vergleich'
    },
    {
      name: 'Cola', kurz: 'Cola', proHundertMl: 10, standard: 330, einheit: 'ml',
      liste: 'Cola (nach Menge)',
      hinweis: 'zum Vergleich'
    },
    {
      name: 'Energydrink', kurz: 'Energydrink', proHundertMl: 32, standard: 250, einheit: 'ml',
      liste: 'Energydrink (nach Menge)',
      hinweis: 'zum Vergleich'
    }
  ];

  // Im Theme: Namen, Listentexte und Hinweise je Getränk, gleiche Reihenfolge.
  if (Array.isArray(TEXTE.getraenke)) {
    TEXTE.getraenke.forEach((t, i) => { if (GETRAENKE[i] && t) Object.assign(GETRAENKE[i], t); });
  }

  /** Koffein einer Portion, je nach Art des Eintrags. */
  function mgVon(index, menge) {
    const g = GETRAENKE[index];
    if (g.mg !== undefined) return g.mg;
    if (g.proGramm !== undefined) return g.proGramm * (menge || g.standard);
    if (g.proHundertMl !== undefined) return g.proHundertMl * (menge || g.standard) / 100;
    return 0;
  }

  /** Text einer Option in der Getränkeauswahl. */
  function optionText(i) {
    const g = GETRAENKE[i];
    const wert = g.mg !== undefined
      ? `${g.mg} mg`
      : tx('option_menge', '{mg} mg bei {menge} {einheit}', { mg: Math.round(mgVon(i)), menge: g.standard, einheit: g.einheit });
    return `${g.liste || g.name} · ${wert}`;
  }

  /** Beschriftung für die Liste im Ergebnis. */
  function nameVon(index, menge) {
    const g = GETRAENKE[index];
    if (g.einheit) return `${g.name}, ${menge || g.standard} ${g.einheit}`;
    return g.name;
  }

  const HALBWERTSZEIT = 5;   // Stunden, gesunder Erwachsener ohne Medikamente
  const SCHLAFGRENZE = 50;   // mg im Körper, ab hier wird Einschlafen schwerer

  let konsum = [];           // {getraenkIndex, stunde, menge}

  // Steht beim ersten Besuch unter «Dein Tag». Die Anleitung löscht genau
  // diese Einträge, bevor sie ihren Beispieltag einträgt.
  const BEISPIELTAG = [
    { getraenkIndex: 1, stunde: 7 },                   // doppelter Espresso
    { getraenkIndex: 0, stunde: 10 },                  // einfacher Espresso
    { getraenkIndex: 3, stunde: 14, menge: 15 }        // Filterkaffee aus 15 g
  ];
  let schlafenszeit = 23;

  /* Messung, seit Theme 0.26.29 (Entscheid Joscha 19.10.2026): dasselbe
     Ereignis wie der alte Koffein-Checker im Live-Theme
     (snippets/caffeine-checker.liquid), mit denselben fünf Werten, damit
     Tag Manager und GA4 unverändert weiterzählen. Nur nach einer Eingabe des
     Besuchers, 3 Sekunden nach der letzten, höchstens einmal pro
     Seitenaufruf. Die Art steht als sprachfreier Schlüssel, gleiche
     Reihenfolge wie GETRAENKE. */
  const MESS_ART = [
    'espresso', 'doppelter_espresso', 'cafe_creme', 'filterkaffee', 'cold_brew', 'matcha',
    'decaf_espresso', 'decaf_filter', 'schwarztee', 'gruentee', 'cola', 'energydrink'
  ];
  let messUhr = null;
  let gemeldet = false;

  function uhrzeit(stunde) {
    const minuten = ((Math.round(stunde * 60) % 1440) + 1440) % 1440;
    return String(Math.floor(minuten / 60)).padStart(2, '0') + ':' +
      String(minuten % 60).padStart(2, '0');
  }

  function messen() {
    if (gemeldet) return;
    clearTimeout(messUhr);
    messUhr = setTimeout(() => {
      if (!konsum.length) return;
      gemeldet = true;
      const folge = konsum.slice().sort((a, b) => a.stunde - b.stunde);
      const arten = [...new Set(folge.map(c => MESS_ART[c.getraenkIndex] || 'andere'))];
      (window.dataLayer = window.dataLayer || []).push({
        event: 'caffeine_checker_submit',
        coffee_count: konsum.length,
        coffee_type: arten.join(','),
        bedtime: uhrzeit(schlafenszeit),
        first_coffee: uhrzeit(folge[0].stunde),
        last_coffee: uhrzeit(folge[folge.length - 1].stunde)
      });
    }, 3000);
  }

  /* liste: ohne Angabe der eingetragene Tag, die Anleitung rechnet damit
     ihren eigenen Beispieltag. */
  function mgZurZeit(stunde, liste = konsum) {
    return liste.reduce((summe, c) => {
      if (stunde < c.stunde) return summe;
      const dosis = mgVon(c.getraenkIndex, c.menge);
      return summe + dosis * Math.pow(0.5, (stunde - c.stunde) / HALBWERTSZEIT);
    }, 0);
  }

  function gesamt(liste = konsum) {
    return liste.reduce((s, c) => s + mgVon(c.getraenkIndex, c.menge), 0);
  }

  /* ------------------------------------------------------------------
     Ergebnis in der Adresse
     Der Stand wird in die URL geschrieben, Format k=index@stunde[xmenge].
     Damit lässt sich ein Ergebnis per Link weitergeben und wiederherstellen.
     Gleichzeitig ist das die Grundlage, falls später ein Dienst daraus ein
     og:image erzeugen soll: Dann trägt der Link alles, was das Bild braucht.
     ------------------------------------------------------------------ */
  function inAdresseSchreiben() {
    if (!konsum.length) return;
    const k = konsum
      .map(c => c.getraenkIndex + '@' + c.stunde + (c.menge ? 'x' + c.menge : ''))
      .join(',');
    const p = new URLSearchParams({ k, s: schlafenszeit });
    // In eingebetteten Vorschauen (Iframe mit Sandbox) darf das scheitern,
    // der Rechner rechnet trotzdem weiter.
    try { history.replaceState(null, '', location.pathname + '?' + p.toString()); } catch (e) { /* egal */ }
  }

  function ausAdresseLesen() {
    const p = new URLSearchParams(location.search);
    const k = p.get('k');
    if (!k) return false;

    const gelesen = k.split(',').map((teil) => {
      const [kopf, menge] = teil.split('x');
      const [index, stunde] = kopf.split('@').map(Number);
      if (!Number.isFinite(index) || !Number.isFinite(stunde)) return null;
      if (!GETRAENKE[index]) return null;
      return {
        getraenkIndex: index,
        stunde: Math.min(23, Math.max(5, stunde)),
        menge: menge ? Number(menge) : undefined
      };
    }).filter(Boolean);

    if (!gelesen.length) return false;
    konsum = gelesen;

    const s = Number(p.get('s'));
    if (Number.isFinite(s) && s >= 19 && s <= 26) schlafenszeit = s;
    return true;
  }

  /* --- Tageskurve als SVG ------------------------------------------------- */
  function kurvePfad(vonStunde, bisStunde, breite, hoehe, maxWert, liste = konsum) {
    const schritte = 96;
    const punkte = [];
    for (let i = 0; i <= schritte; i++) {
      const std = vonStunde + (bisStunde - vonStunde) * (i / schritte);
      const wert = mgZurZeit(std, liste);
      const x = (i / schritte) * breite;
      const y = hoehe - (wert / maxWert) * hoehe;
      punkte.push(`${x.toFixed(1)},${Math.max(0, y).toFixed(1)}`);
    }
    return 'M' + punkte.join(' L');
  }

  function zeichneKurve() {
    const svg = document.getElementById('koffein-kurve');
    if (!svg) return;

    const B = 600, H = 180;
    const maxWert = Math.max(150, gesamt() * 0.85);
    const linie = kurvePfad(5, 26, B, H, maxWert);
    const flaeche = linie + ` L${B},${H} L0,${H} Z`;

    svg.querySelector('.kurve-linie').setAttribute('d', linie);
    svg.querySelector('.kurve-flaeche').setAttribute('d', flaeche);

    // Schlafenszeit als Markierung
    const xSchlaf = ((schlafenszeit - 5) / 21) * B;
    const marke = svg.querySelector('.schlaf-marke');
    marke.setAttribute('x1', xSchlaf); marke.setAttribute('x2', xSchlaf);
    const text = svg.querySelector('.schlaf-text');
    text.setAttribute('x', Math.min(xSchlaf + 6, B - 60));

    // Grenzlinie mit Beschriftung, sonst weiss niemand, was sie bedeutet.
    const ySchwelle = Math.max(12, H - (SCHLAFGRENZE / maxWert) * H);
    const schwelle = svg.querySelector('.schwelle');
    schwelle.setAttribute('y1', ySchwelle);
    schwelle.setAttribute('y2', ySchwelle);

    const schwelleText = svg.querySelector('.schwelle-text');
    if (schwelleText) schwelleText.setAttribute('y', ySchwelle - 7);

    /* An jeden Hochpunkt schreiben, was dort getrunken wurde. Die Labels
       stehen abwechselnd höher und tiefer, damit sie sich bei mehreren
       Getränken kurz nacheinander nicht überlagern. */
    const marken = svg.querySelector('.kurve-marken');
    if (marken) {
      marken.innerHTML = konsum
        .slice()
        .sort((a, b) => a.stunde - b.stunde)
        .map((c, i) => {
          const x = ((c.stunde - 5) / 21) * B;
          const wert = mgZurZeit(c.stunde);
          const y = Math.max(6, H - (wert / maxWert) * H);
          const hoch = (i % 2 === 0) ? 26 : 46;          // versetzt stapeln
          const yText = Math.max(12, y - hoch);
          const name = GETRAENKE[c.getraenkIndex].kurz || GETRAENKE[c.getraenkIndex].name;
          // Labels am rechten Rand nach links ausrichten, sonst ragen sie raus.
          const anker = x > B - 80 ? 'end' : (x < 60 ? 'start' : 'middle');
          const xText = anker === 'end' ? x - 4 : (anker === 'start' ? x + 4 : x);

          return `<g class="kurve-marke">
            <line x1="${x.toFixed(1)}" y1="${(y - 5).toFixed(1)}"
                  x2="${x.toFixed(1)}" y2="${(yText + 5).toFixed(1)}"
                  stroke="rgba(255,243,232,.5)" stroke-width="1.5"/>
            <circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="4.5"
                    fill="#FFF3E8" stroke="#FF4612" stroke-width="2"/>
            <text x="${xText.toFixed(1)}" y="${yText.toFixed(1)}" text-anchor="${anker}"
                  fill="rgba(255,243,232,.92)"
                  style="font:700 12px Gabarito,sans-serif">${name}</text>
          </g>`;
        }).join('');

      if (!ruhig) {
        gsap.from(marken.children, {
          opacity: 0, y: 8, duration: 0.5, stagger: 0.07, ease: 'bw-aus', overwrite: true
        });
      }
    }

    if (!ruhig) {
      gsap.fromTo(svg.querySelector('.kurve-linie'),
        { drawSVG: '0% 0%' }, { drawSVG: '0% 100%', duration: 0.9, ease: 'power2.out', overwrite: true });
      gsap.fromTo(svg.querySelector('.kurve-flaeche'),
        { opacity: 0 }, { opacity: 0.22, duration: 0.7, ease: 'power2.out', overwrite: true });
    }
  }

  /* --- Ergebnis schreiben ------------------------------------------------- */
  function aktualisiere() {
    const rest = mgZurZeit(schlafenszeit);
    const summe = gesamt();

    setzeZahl('#wert-gesamt', summe);
    setzeZahl('#wert-rest', rest);

    const anteil = Math.min(1, rest / 200);
    const fuellung = document.querySelector('#balken-rest .fuellung');
    if (fuellung) {
      // Ruhig ohne GSAP gesetzt, damit «Hinzufügen» auch geht, wenn GSAP fehlt.
      if (ruhig) fuellung.style.transform = `scaleX(${anteil})`;
      else gsap.to(fuellung, { scaleX: anteil, duration: 0.7, ease: 'bw-aus', overwrite: true });
      fuellung.style.background = rest > SCHLAFGRENZE ? 'var(--redorange)' : 'var(--cyanblau)';
    }

    const urteil = document.getElementById('urteil');
    if (urteil) {
      if (summe === 0) {
        urteil.textContent = tx('urteil_leer', 'Trag oben ein, was Du heute getrunken hast.');
      } else if (rest > 100) {
        urteil.innerHTML = tx('urteil_viel', 'Beim Schlafengehen sind noch <strong>{mg} mg</strong> in Dir. ' +
          'Das ist etwa ein doppelter Espresso, den Du mit ins Bett nimmst. Der letzte Kaffee dürfte früher sein.', { mg: Math.round(rest) });
      } else if (rest > SCHLAFGRENZE) {
        urteil.innerHTML = tx('urteil_mittel', 'Noch <strong>{mg} mg</strong> im Körper. ' +
          'Einschlafen geht meist, aber die Tiefschlafphasen leiden. Zwei Stunden früher wäre besser.', { mg: Math.round(rest) });
      } else {
        urteil.innerHTML = tx('urteil_wenig', 'Nur noch <strong>{mg} mg</strong>. ' +
          'Das steht Deinem Schlaf nicht im Weg. Passt so.', { mg: Math.round(rest) });
      }
    }

    const menge = document.getElementById('tagesmenge');
    if (menge) {
      if (summe > 400) {
        menge.hidden = false;
        menge.innerHTML = tx('tagesmenge', '<strong>{mg} mg</strong> am Tag liegen über der Menge, ' +
          'die die EFSA für gesunde Erwachsene als unbedenklich einstuft (400 mg). ' +
          'Kein Drama an einem einzelnen Tag, aber dauerhaft einen Blick wert.', { mg: Math.round(summe) });
      } else {
        menge.hidden = true;
      }
    }

    // Der Teilen-Knopf taucht erst auf, wenn es etwas zu zeigen gibt.
    const teilen = document.getElementById('teilen-knopf');
    if (teilen) {
      const zeigen = konsum.length > 0;
      if (zeigen && teilen.hidden) {
        teilen.hidden = false;
        if (!ruhig) gsap.from(teilen, { opacity: 0, y: 14, duration: 0.5, ease: 'bw-aus' });
      } else if (!zeigen) {
        teilen.hidden = true;
      }
    }

    inAdresseSchreiben();
    zeichneListe();
    zeichneKurve();
  }

  function setzeZahl(auswahl, wert) {
    const el = document.querySelector(auswahl);
    if (!el) return;
    const von = parseFloat(el.dataset.wert || '0');
    const stand = { v: von };
    el.dataset.wert = wert;

    if (ruhig) {
      el.innerHTML = Math.round(wert) + '<span class="einheit"> mg</span>';
      return;
    }
    gsap.to(stand, {
      v: wert, duration: 0.7, ease: 'power2.out', overwrite: true,
      onUpdate: () => { el.innerHTML = Math.round(stand.v) + '<span class="einheit"> mg</span>'; }
    });
  }

  function zeichneListe() {
    const liste = document.getElementById('konsum-liste');
    if (!liste) return;

    if (!konsum.length) {
      liste.innerHTML = '<p style="opacity:.6;font-size:.9rem">' + tx('liste_leer', 'Noch nichts eingetragen.') + '</p>';
      return;
    }

    liste.innerHTML = konsum
      .slice()
      .sort((a, b) => a.stunde - b.stunde)
      .map((c) => {
        const echterIndex = konsum.indexOf(c);
        return `<div class="zutat">
          <span>${String(c.stunde).padStart(2, '0')}:00 · ${nameVon(c.getraenkIndex, c.menge)}</span>
          <span class="menge">${Math.round(mgVon(c.getraenkIndex, c.menge))} mg
            <button class="entfernen" data-weg="${echterIndex}" aria-label="${tx('entfernen', 'Entfernen')}"
                    style="margin-left:8px;color:inherit;opacity:.5">✕</button>
          </span>
        </div>`;
      }).join('');
  }

  /* --- Aufbau ------------------------------------------------------------- */
  function koffeinrechner() {
    const auswahl = document.getElementById('getraenk-auswahl');
    const zeit = document.getElementById('konsum-zeit');
    const schlaf = document.getElementById('schlaf-zeit');
    const hinzu = document.getElementById('hinzufuegen');
    const liste = document.getElementById('konsum-liste');

    const mengenfeld = document.getElementById('mengenfeld');
    const menge = document.getElementById('menge');
    const mengenLabel = document.getElementById('menge-label');
    const hinweisZeile = document.getElementById('getraenk-hinweis');

    if (!auswahl) return;

    koffeinAnleitung();

    /* In der Liste steht gleich dabei, welche Getränke dazugehören.
       Sonst muss man raten, ob ein Flat White ein oder zwei Shots hat. */
    auswahl.innerHTML = GETRAENKE.map((g, i) => `<option value="${i}">${optionText(i)}</option>`).join('');

    /* Nur Getränke mit eigener Menge bekommen ein Eingabefeld. */
    function feldAnpassen() {
      const g = GETRAENKE[+auswahl.value];
      hinweisZeile.textContent = g.hinweis || '';

      if (g.einheit) {
        mengenfeld.hidden = false;
        mengenLabel.textContent = g.einheit === 'g'
          ? tx('menge_kaffee', 'Wie viel Kaffee hast Du verwendet?')
          : tx('menge_getraenk', 'Wie viel hast Du getrunken?');
        menge.value = g.standard;
        menge.step = g.einheit === 'g' ? 1 : 10;
        menge.min = g.einheit === 'g' ? 5 : 50;
        menge.max = g.einheit === 'g' ? 120 : 1000;
        document.getElementById('menge-einheit').textContent = g.einheit;
      } else {
        mengenfeld.hidden = true;
      }
    }

    auswahl.addEventListener('change', feldAnpassen);
    feldAnpassen();

    // Ein Ergebnis aus der Adresse hat Vorrang, sonst ein typischer Tag.
    if (!ausAdresseLesen()) {
      konsum = BEISPIELTAG.map(c => ({ ...c }));
    }

    hinzu.addEventListener('click', () => {
      const g = GETRAENKE[+auswahl.value];
      konsum.push({
        getraenkIndex: +auswahl.value,
        stunde: +zeit.value,
        menge: g.einheit ? +menge.value : undefined
      });
      aktualisiere();
      messen();
      if (!ruhig) {
        gsap.fromTo(liste.lastElementChild || liste,
          { opacity: 0, x: -14 }, { opacity: 1, x: 0, duration: 0.45, ease: 'bw-aus' });
      }
    });

    liste.addEventListener('click', (e) => {
      const knopf = e.target.closest('[data-weg]');
      if (!knopf) return;
      konsum.splice(+knopf.dataset.weg, 1);
      aktualisiere();
      messen();
    });

    zeit.addEventListener('input', () => {
      document.getElementById('zeit-anzeige').textContent =
        String(zeit.value).padStart(2, '0') + ':00';
    });

    schlaf.addEventListener('input', () => {
      schlafenszeit = +schlaf.value;
      document.getElementById('schlaf-anzeige').textContent =
        String(schlaf.value).padStart(2, '0') + ':00';
      aktualisiere();
      messen();
    });

    // Kam der Stand aus einem Link, müssen Regler und Anzeige nachziehen.
    schlaf.value = schlafenszeit;
    document.getElementById('schlaf-anzeige').textContent =
      String(schlafenszeit % 24).padStart(2, '0') + ':00';

    const teilen = document.getElementById('teilen-knopf');
    if (teilen) {
      teilen.addEventListener('click', async () => {
        const alt = teilen.textContent;
        teilen.textContent = tx('bild_wird_gebaut', 'Bild wird gebaut …');
        teilen.disabled = true;
        try {
          const flaeche = await zeichneTeilenBild();
          teilenDialog(flaeche);
        } finally {
          teilen.textContent = alt;
          teilen.disabled = false;
        }
      });
    }

    aktualisiere();
  }

  /* ======================================================================
     Anleitung zum Rechner
     Über dem Rechner steht nur der Knopf «Anleitung». Er öffnet ein Popup,
     in dem ein Nachbau des Rechners in gut einer halben Minute (ANLEITUNG.dauer) einen Beispieltag
     einträgt: Beispiele mit ✕ löschen, Cappuccino um 8:15, doppelter
     Espresso um 17:15, Decaf um 20:00, das Ergebnis ablesen und es auf
     Social Media teilen.

     Zwei Formate, je nach Breite wie der echte Rechner (zweispaltig ab
     861 px, siehe seiten.css):
       quer  Eingaben links, Ergebnisbox rechts. Die Box rechnet nach jedem
             ✕ und jedem «Hinzufügen» mit, wie die echte.
       hoch  nur die Eingaben, am Schluss fährt die Ergebniskarte herein.

     Gezeichnet als Inline-SVG, abgespielt mit einer GSAP-Zeitleiste. Alle
     Beschriftungen des Nachbaus liest sie aus dem echten Rechner und aus
     GETRAENKE, im Theme stehen sie dort schon in der Sprache der Seite. Nur
     die eigenen Texte (Knopf, Schritte, Sprechblasen) laufen über tx(),
     Schlüssel anleitung_*.

     Platz für den Knopf ist #koffein-anleitung über dem Rechner, aus
     werkzeug/vorlagen/koffeinrechner.html. Fehlt er, passiert nichts.
     ====================================================================== */

  // Joschas Beispieltag. uhr ist die echte Uhrzeit, stunde das, was der
  // Regler kann: Er springt in vollen Stunden, aus 8:15 wird 08:00.
  const ANLEITUNG = {
    tag: [
      { getraenkIndex: 0, stunde: 8, uhr: '8:15' },     // Cappuccino
      { getraenkIndex: 1, stunde: 17, uhr: '17:15' },   // doppelter Espresso
      { getraenkIndex: 6, stunde: 20, uhr: '20:00' }    // Decaf Espresso
    ],
    schlaf: 23,
    // Anfang der sechs Kapitel in Sekunden, das letzte endet bei dauer.
    kapitel: [0, 6, 13, 19, 24, 30],
    dauer: 37,
    // Ab hier quer, gleiche Grenze wie .rechner in seiten.css.
    quer: '(min-width: 861px)'
  };

  // Masse des Nachbaus. Die Eingabespalte (0 bis 480) ist in beiden Formaten
  // dieselbe, quer kommt rechts die Ergebnisbox dazu. Die Abstände folgen
  // der echten Eingabespalte, nur etwas enger.
  const AF = {
    rot: '#FF4612', blau: '#004B5C', cyan: '#4FC4E2', hell: '#FFF3E8',
    linie: 'rgba(0,75,92,.16)', rand: 'rgba(0,75,92,.28)', spur: '#3D3D3D'
  };
  const AB = 480, AB_QUER = 960, AH = 560;
  const AZEILE = 44;                       // Zeilenhöhe unter «Dein Tag»
  const AZEILEN_Y = 408;                   // oberste Zeile
  const AOPTION = 26;                      // Zeilenhöhe der offenen Auswahl
  const ALISTE_Y = 102;                    // Oberkante der offenen Auswahl
  const AREGLER = {
    zeit: { x: 26, b: 428, y: 186, von: 5, bis: 23 },
    schlaf: { x: 26, b: 428, y: 336, von: 19, bis: 26 }
  };
  const AKNOPF = { x: 24, y: 232, h: 44 };
  // hoch: Ergebniskarte, fährt am Schluss von oben herein, mit ihrer Kurve.
  const AKARTE = { x: 16, y: 16, b: 448, h: 268 };
  const AKURVE = { x: 40, y: 140, b: 400, h: 104 };
  // quer: Ergebnisbox rechts, wie .rechner-ergebnis, mit ihrer Kurve.
  const ABOX = { x: 504, y: 36, b: 432, h: 488 };
  const ABOX_KURVE = { x: 28, y: 214, b: 376, h: 132 };
  // Teilen: Der Knopf steht unter dem Rechner, die Seite scrollt um ASCROLL
  // hoch, dann öffnet sich das Teilen-Fenster in der Mitte der Bühne.
  const ATEILEN_KNOPF = { x: 24, y: 576, h: 44 };
  const ASCROLL = 90;
  const AFENSTER_B = 380;

  const reglerX = (r, h) => r.x + (h - r.von) / (r.bis - r.von) * r.b;
  const uhrText = (h) => String(h % 24).padStart(2, '0') + ':00';
  // [<] statt des nackten Zeichens: Theme Check liest tools.js.liquid als
  // HTML und hielte Schrägstrich, Kleiner-als und g für ein schliessendes Tag.
  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/[<]/g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  /** Beschriftungen aus dem echten Rechner, mit deutschem Rückfall. */
  function rechnerTexte() {
    const q = (s) => document.querySelector(s);
    // Nur die Textknoten direkt im Element, ohne «Aktuell 08:00» daneben.
    const eigen = (el, ersatz) => {
      if (!el) return ersatz;
      const t = Array.from(el.childNodes).filter(n => n.nodeType === 3)
        .map(n => n.textContent).join(' ').replace(/\s+/g, ' ').trim();
      return t || ersatz;
    };
    const text = (el, ersatz) => (el && el.textContent.replace(/\s+/g, ' ').trim()) || ersatz;
    const bereich = (id, ersatz) => {
      const feld = q('#' + id) && q('#' + id).closest('.rechner-feld');
      const spans = feld ? feld.querySelectorAll('.bereich-werte span') : [];
      return spans.length === 2 ? [spans[0].textContent.trim(), spans[1].textContent.trim()] : ersatz;
    };
    const zeit = q('#konsum-zeit'), schlaf = q('#schlaf-zeit');
    const liste = q('#konsum-liste');
    const rest = q('#wert-rest');
    const skala = q('.rechner-ergebnis .rechner-skala');
    const zeilen = Array.from(document.querySelectorAll('.rechner-ergebnis .rechner-zeile'))
      .map(z => [text(z.children[0], ''), text(z.children[1], '')]);
    return {
      getrunken: eigen(q('label[for="getraenk-auswahl"]'), 'Was hast Du getrunken?'),
      uhrzeit: eigen(q('label[for="konsum-zeit"]'), 'Um wie viel Uhr?'),
      schlafen: eigen(q('label[for="schlaf-zeit"]'), 'Wann gehst Du schlafen?'),
      aktuell: eigen(q('label[for="konsum-zeit"] .hinweis'), 'Aktuell'),
      tag: eigen(liste && liste.closest('.rechner-feld').querySelector('label'), 'Dein Tag'),
      hinzufuegen: eigen(q('#hinzufuegen'), 'Hinzufügen'),
      zeitBereich: bereich('konsum-zeit', ['05:00', '23:00']),
      schlafBereich: bereich('schlaf-zeit', ['19:00', '02:00']),
      rechner: text(q('.rechner-ergebnis .box-kopf .eyebrow'), 'Koffeinrechner'),
      rest: text(rest && rest.previousElementSibling, 'Beim Schlafengehen noch im Körper'),
      skala: skala && skala.children.length === 3
        ? Array.from(skala.children).map(s => text(s, ''))
        : ['0 mg', '50 mg · Schlafgrenze', '200 mg'],
      // «Insgesamt heute» rechnet mit, «Halbwertszeit» steht fest.
      zeilen: zeilen.length >= 2 ? zeilen.slice(0, 2) : [['Insgesamt heute', ''], ['Halbwertszeit', 'rund 5 Stunden']],
      schlafenszeit: eigen(q('#koffein-kurve .schlaf-text'), 'Schlafenszeit'),
      teilen: text(q('#teilen-knopf'), 'Auf Social Media teilen'),
      leer: tx('liste_leer', 'Noch nichts eingetragen.'),
      // Startwerte der Regler, wie sie in der Vorlage stehen.
      zeitStart: +(zeit && zeit.getAttribute('value')) || 8,
      schlafStart: +(schlaf && schlaf.getAttribute('value')) || 23
    };
  }

  /** Was gerechnet wird: der Beispieltag und die Stände der Ergebnisbox. */
  function anleitungSzenario() {
    const tag = ANLEITUNG.tag;
    const liste = tag.map(c => ({ getraenkIndex: c.getraenkIndex, stunde: c.stunde }));
    const stand = (l) => {
      const summe = gesamt(l);
      return { liste: l, rest: mgZurZeit(ANLEITUNG.schlaf, l), summe, maxWert: Math.max(150, summe * 0.85) };
    };
    // Die Box zeigt erst die Beispiele, nach jedem ✕ eines weniger, dann
    // nach jedem «Hinzufügen» ein Getränk mehr. Gelöscht wird immer oben.
    const zustaende = [0, 1, 2, 3].map(n => stand(BEISPIELTAG.slice(n)))
      .concat([1, 2, 3].map(n => stand(liste.slice(0, n))));
    const ende = stand(liste);
    return { tag, liste, rest: ende.rest, maxWert: ende.maxWert, zustaende };
  }

  /** Die sechs Schritte als Text: Untertitel, Screenreader und Ersatz ohne
      Bewegung. nativ: Teilen läuft über das Teilen-Menü des Geräts. */
  function anleitungSchritte(T, rest, nativ) {
    const TT = teilenTexte();
    const [a, b, c] = ANLEITUNG.tag;
    const werte = (e) => ({
      uhr: e.uhr, stunde: uhrText(e.stunde), name: GETRAENKE[e.getraenkIndex].name,
      knopf: T.hinzufuegen, mg: Math.round(mgVon(e.getraenkIndex))
    });
    return [
      {
        kurz: tx('anleitung_1_kurz', 'Beispiele löschen'),
        text: tx('anleitung_1_text', 'Unter «{tag}» stehen schon Beispiele. Lösch jedes mit ✕, sonst zählt es mit.', { tag: T.tag })
      },
      {
        kurz: tx('anleitung_2_kurz', 'Cappuccino um {uhr}', werte(a)),
        text: tx('anleitung_2_text', 'Ein Cappuccino zählt als einfacher Espresso. Wähl «{name}», stell den Regler auf {stunde} und drück «{knopf}». Der Regler springt in vollen Stunden, aus {uhr} wird {stunde}.', werte(a))
      },
      {
        kurz: tx('anleitung_3_kurz', 'Doppelter Espresso um {uhr}', werte(b)),
        text: tx('anleitung_3_text', 'Wähl «{name}», stell den Regler auf {stunde} und drück wieder «{knopf}».', werte(b))
      },
      {
        kurz: tx('anleitung_4_kurz', 'Decaf um {uhr}', werte(c)),
        text: tx('anleitung_4_text', 'Wähl «{name}», Regler auf {stunde}, «{knopf}». Mit {mg} mg fällt der Decaf kaum ins Gewicht.', werte(c))
      },
      {
        kurz: tx('anleitung_5_kurz', 'Ergebnis ablesen'),
        text: tx('anleitung_5_text', 'Stell ein, wann Du schlafen gehst. Neben den Eingaben, auf dem Handy darunter, steht dann, wie viel Koffein beim Einschlafen noch in Dir ist. Bei diesem Tag sind es um {schlaf} noch {mg} mg.',
          { schlaf: uhrText(ANLEITUNG.schlaf), mg: Math.round(rest) })
      },
      {
        kurz: tx('anleitung_6_kurz', 'Ergebnis teilen'),
        text: nativ
          ? tx('anleitung_6_text_nativ', 'Unter dem Rechner steht «{knopf}». Er baut ein Bild mit Deinem Ergebnis. «{teilen}» schickt Bild und Text an die App Deiner Wahl, zum Beispiel Instagram.',
            { knopf: T.teilen, teilen: TT.bildTeilen })
          : tx('anleitung_6_text_ablage', 'Unter dem Rechner steht «{knopf}». Er baut ein Bild mit Deinem Ergebnis. Klick auf die Plattform, dann liegt das Bild in der Zwischenablage und Du fügst es mit {taste} in den Beitrag ein.',
            { knopf: T.teilen, taste: TT.taste })
      }
    ];
  }

  /* --- Zeichnung ------------------------------------------------------------ */

  function aText(x, y, inhalt, stil, extra = '') {
    return `<text x="${x}" y="${y}" style="${stil}" ${extra}>${inhalt}</text>`;
  }
  const LABEL = `font:700 11px Gabarito,sans-serif;letter-spacing:1.4px;fill:${AF.blau}`;
  const KLEIN_HELL = `font:500 10.5px Gabarito,sans-serif;fill:${AF.hell};fill-opacity:.7`;

  /** Label wie .rechner-feld label, auf Wunsch mit «Aktuell 08:00» daneben. */
  function aLabel(y, text, wert, wertKlasse) {
    const gross = esc(text.toLocaleUpperCase('de-CH'));
    if (wert === undefined) return aText(24, y, gross, LABEL);
    return `<text x="24" y="${y}" style="${LABEL}">${gross}` +
      `<tspan dx="10" style="font:400 12px Gabarito,sans-serif;letter-spacing:0;fill-opacity:.62">${esc(wert.aktuell)}</tspan>` +
      `<tspan dx="5" class="${wertKlasse}" style="font:800 17px Gabarito,sans-serif;letter-spacing:-.3px;fill:${AF.rot}">${esc(wert.uhr)}</tspan></text>`;
  }

  function aRegler(r, h, klasse, bereich) {
    const x = reglerX(r, h);
    return `<g class="${klasse}">
      <rect x="${r.x}" y="${r.y - 2.5}" width="${r.b}" height="5" rx="2.5" fill="${AF.spur}"/>
      <rect class="anl-fuell" x="${r.x}" y="${r.y - 2.5}" width="${x - r.x}" height="5" rx="2.5" fill="${AF.rot}"/>
      <circle class="anl-daumen" cx="${x}" cy="${r.y}" r="8" fill="${AF.rot}" stroke="#fff" stroke-width="2.5"/>
    </g>` +
      aText(24, r.y + 26, esc(bereich[0]), 'font:500 11.5px Gabarito,sans-serif;fill:' + AF.blau + ';fill-opacity:.6') +
      aText(456, r.y + 26, esc(bereich[1]), 'font:500 11.5px Gabarito,sans-serif;fill:' + AF.blau + ';fill-opacity:.6', 'text-anchor="end"');
  }

  /** Eine Zeile unter «Dein Tag», wie zeichneListe() sie schreibt. */
  function aZeile(c, klasse, i) {
    const name = `${uhrText(c.stunde)} · ${nameVon(c.getraenkIndex, c.menge)}`;
    return `<g class="${klasse}" data-i="${i}">
      ${aText(24, 28, esc(name), `font:500 15px Gabarito,sans-serif;fill:${AF.blau}`, 'data-max="300"')}
      ${aText(420, 28, Math.round(mgVon(c.getraenkIndex, c.menge)) + ' mg', `font:700 15px Gabarito,sans-serif;fill:${AF.rot}`, 'text-anchor="end"')}
      ${aText(446, 28, '✕', `font:700 15px Gabarito,sans-serif;fill:${AF.rot};fill-opacity:.55`, 'text-anchor="middle"')}
      <line x1="24" y1="${AZEILE}" x2="456" y2="${AZEILE}" stroke="${AF.linie}" stroke-width="1"/>
    </g>`;
  }

  /** Sprechblase. x/y ist die Spitze, richtung sagt, wohin sie zeigt.
      Auf dunklem Grund (Ergebnisbox) in Rotorange statt Dunkelblau. */
  function aBlase(klasse, text, x, y, richtung, anker, farbe = AF.blau) {
    return `<g class="anl-blase ${klasse}" transform="translate(${x} ${y})" data-richtung="${richtung}" data-anker="${anker || 'mitte'}">
      <g class="anl-blase-innen">
        <rect rx="8" height="28" fill="${farbe}"/>
        <path fill="${farbe}"/>
        <text style="font:700 13px Gabarito,sans-serif;fill:${AF.hell}">${esc(text)}</text>
      </g>
    </g>`;
  }

  /** Tageskurve eines Stands: Schwelle, Fläche, Linie, Marken, Schlafenszeit
      zeichnet der Aufrufer. Rechnet wie zeichneKurve(). */
  function aKurve(z, b, h, klasse, markenSichtbar) {
    const linie = kurvePfad(5, 26, b, h, z.maxWert, z.liste);
    const ySchwelle = Math.max(12, h - (SCHLAFGRENZE / z.maxWert) * h);
    const marken = z.liste.slice().sort((p, q) => p.stunde - q.stunde).map((c, i) => {
      const x = ((c.stunde - 5) / 21) * b;
      const y = Math.max(5, h - (mgZurZeit(c.stunde, z.liste) / z.maxWert) * h);
      const yText = Math.max(10, y - (i % 2 === 0 ? 14 : 28));
      const anker = x > b - 70 ? 'end' : (x < 50 ? 'start' : 'middle');
      return `<g class="anl-marke"${markenSichtbar ? '' : ' opacity="0"'}>
        <circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="3.5" fill="${AF.hell}" stroke="${AF.rot}" stroke-width="1.8"/>
        ${aText(x.toFixed(1), yText.toFixed(1), esc(GETRAENKE[c.getraenkIndex].kurz || GETRAENKE[c.getraenkIndex].name),
          `font:700 10px Gabarito,sans-serif;fill:${AF.hell};fill-opacity:.92`, `text-anchor="${anker}"`)}
      </g>`;
    }).join('');
    return `<g class="${klasse}">
      <line x1="0" y1="${ySchwelle.toFixed(1)}" x2="${b}" y2="${ySchwelle.toFixed(1)}" stroke="${AF.hell}" stroke-opacity=".45" stroke-width="1.2" stroke-dasharray="4 4"/>
      ${aText(2, (ySchwelle - 5).toFixed(1), '50 mg', `font:600 10px Gabarito,sans-serif;fill:${AF.hell};fill-opacity:.75`)}
      <path class="anl-flaeche" d="${linie} L${b},${h} L0,${h} Z" fill="${AF.rot}" opacity="0"/>
      <path class="anl-kurve" d="${linie}" fill="none" stroke="${AF.rot}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      ${marken}
    </g>`;
  }

  /** Schlafenszeit als senkrechte Linie mit Beschriftung. Die steht rechts
      der Linie und darf über die Kurve hinaus in den Rand der Box ragen;
      links stiesse sie an die Marke des letzten Getränks. */
  function aSchlaf(T, b, h) {
    const x = ((ANLEITUNG.schlaf - 5) / 21) * b;
    return `<line x1="${x.toFixed(1)}" y1="0" x2="${x.toFixed(1)}" y2="${h}" stroke="${AF.cyan}" stroke-width="1.6" stroke-dasharray="3 3"/>
      ${aText((x + 5).toFixed(1), 10, esc(T.schlafenszeit), `font:600 10px Gabarito,sans-serif;fill:${AF.cyan}`)}`;
  }

  /** hoch: die Ergebniskarte, die am Schluss von oben hereinfährt. */
  function aErgebnisKarte(T, szenario) {
    const ende = szenario.zustaende[szenario.zustaende.length - 1];
    const k = AKURVE;
    return `<g class="anl-ergebnis" opacity="0">
      <rect x="${AKARTE.x}" y="${AKARTE.y}" width="${AKARTE.b}" height="${AKARTE.h}" rx="14" fill="${AF.blau}"
            style="filter:drop-shadow(0 10px 22px rgba(0,75,92,.28))"/>
      ${aText(40, 50, esc(T.rest.toLocaleUpperCase('de-CH')), `font:700 10.5px Gabarito,sans-serif;letter-spacing:1.3px;fill:${AF.cyan}`, 'data-max="400"')}
      <text x="40" y="100" style="font:900 50px Gabarito,sans-serif;letter-spacing:-1.5px;fill:${AF.hell}"><tspan class="anl-zahl">0</tspan><tspan dx="6" style="font:700 17px Gabarito,sans-serif;letter-spacing:0;fill-opacity:.8">mg</tspan></text>
      <rect x="40" y="116" width="400" height="8" rx="4" fill="${AF.hell}" fill-opacity=".18"/>
      <rect class="anl-balken" x="40" y="116" width="0" height="8" rx="4" fill="${ende.rest > SCHLAFGRENZE ? AF.rot : AF.cyan}"
            data-ziel="${(400 * Math.min(1, ende.rest / 200)).toFixed(1)}"/>
      <g transform="translate(${k.x} ${k.y})">
        <line x1="0" y1="${k.h}" x2="${k.b}" y2="${k.h}" stroke="${AF.hell}" stroke-opacity=".3" stroke-width="1.2"/>
        ${aKurve(ende, k.b, k.h, 'anl-karte-kurve', false)}
        ${aSchlaf(T, k.b, k.h)}
      </g>
      ${aText(40, 266, '05:00', KLEIN_HELL)}
      ${aText(240, 266, '14:00', KLEIN_HELL, 'text-anchor="middle"')}
      ${aText(440, 266, '02:00', KLEIN_HELL, 'text-anchor="end"')}
    </g>`;
  }

  /** quer: die Ergebnisbox rechts, wie .rechner-ergebnis. Jeder Stand hat
      eine eigene Kurve, die Zeitleiste blendet sie nacheinander ein. */
  function aErgebnisBox(T, szenario) {
    const B = ABOX, k = ABOX_KURVE;
    const z0 = szenario.zustaende[0];
    const innen = B.b - 2 * 28;
    const [zeile1, zeile2] = T.zeilen;
    return `<g class="anl-box" transform="translate(${B.x} ${B.y})">
      <rect width="${B.b}" height="${B.h}" rx="16" fill="${AF.blau}"/>
      ${aText(28, 42, esc(T.rechner.toLocaleUpperCase('de-CH')), `font:700 10.5px Gabarito,sans-serif;letter-spacing:1.3px;fill:${AF.cyan}`)}
      <line x1="28" y1="62" x2="${28 + innen}" y2="62" stroke="${AF.hell}" stroke-opacity=".14"/>
      ${aText(28, 94, esc(T.rest.toLocaleUpperCase('de-CH')), `font:700 10.5px Gabarito,sans-serif;letter-spacing:1.3px;fill:${AF.cyan}`, `data-max="${innen}"`)}
      <text class="anl-box-zahltext" x="28" y="148" style="font:900 52px Gabarito,sans-serif;letter-spacing:-1.5px;fill:${AF.hell}"><tspan class="anl-box-zahl">${Math.round(z0.rest)}</tspan><tspan dx="6" style="font:700 18px Gabarito,sans-serif;letter-spacing:0;fill-opacity:.8">mg</tspan></text>
      <rect x="28" y="166" width="${innen}" height="9" rx="4.5" fill="${AF.hell}" fill-opacity=".18"/>
      <rect class="anl-box-balken" x="28" y="166" width="${(innen * Math.min(1, z0.rest / 200)).toFixed(1)}" height="9" rx="4.5"
            fill="${z0.rest > SCHLAFGRENZE ? AF.rot : AF.cyan}"/>
      ${aText(28, 192, esc(T.skala[0]), KLEIN_HELL)}
      ${aText(28 + innen / 2, 192, esc(T.skala[1]), KLEIN_HELL, 'text-anchor="middle"')}
      ${aText(28 + innen, 192, esc(T.skala[2]), KLEIN_HELL, 'text-anchor="end"')}
      <g transform="translate(${k.x} ${k.y})">
        <line x1="0" y1="${k.h}" x2="${k.b}" y2="${k.h}" stroke="${AF.hell}" stroke-opacity=".3" stroke-width="1.2"/>
        ${szenario.zustaende.map((z) => aKurve(z, k.b, k.h, 'anl-stand', true)).join('')}
        ${aSchlaf(T, k.b, k.h)}
      </g>
      ${aText(28, k.y + k.h + 20, '05:00', KLEIN_HELL)}
      ${aText(28 + innen / 2, k.y + k.h + 20, '14:00', KLEIN_HELL, 'text-anchor="middle"')}
      ${aText(28 + innen, k.y + k.h + 20, '02:00', KLEIN_HELL, 'text-anchor="end"')}
      ${aText(28, 408, esc(zeile1[0]), `font:500 13px Gabarito,sans-serif;fill:${AF.hell}`)}
      <text x="${28 + innen}" y="408" text-anchor="end" style="font:700 13px Gabarito,sans-serif;fill:${AF.hell}"><tspan class="anl-box-summe">${Math.round(z0.summe)}</tspan> mg</text>
      <line x1="28" y1="426" x2="${28 + innen}" y2="426" stroke="${AF.hell}" stroke-opacity=".14"/>
      ${aText(28, 454, esc(zeile2[0]), `font:500 13px Gabarito,sans-serif;fill:${AF.hell}`)}
      ${aText(28 + innen, 454, esc(zeile2[1]), `font:700 13px Gabarito,sans-serif;fill:${AF.hell}`, 'text-anchor="end"')}
    </g>`;
  }

  /** Text in Zeilen nach Zeichenzahl, für die Erklärungen im Teilen-Fenster. */
  function aUmbruch(text, x, y, zeichen, abstand, stil, extra = '') {
    const zeilen = [];
    // Nur an normalen Leerzeichen trennen, feste (Strg + V) bleiben stehen.
    String(text).split(/[ \t\n]+/).forEach((wort) => {
      const letzte = zeilen[zeilen.length - 1];
      if (letzte !== undefined && (letzte + ' ' + wort).length <= zeichen) zeilen[zeilen.length - 1] = letzte + ' ' + wort;
      else zeilen.push(wort);
    });
    return `<text x="${x}" y="${y}" style="${stil}" ${extra}>` +
      zeilen.map((z, i) => `<tspan x="${x}" dy="${i ? abstand : 0}">${esc(z)}</tspan>`).join('') + '</text>';
  }

  /** Umriss-Knopf wie .btn--linie, Text in der Mitte. */
  function aLinienKnopf(x, y, b, h, text, klasse = '') {
    return `<g class="${klasse}">
      <rect x="${x}" y="${y}" width="${b}" height="${h}" rx="8" fill="${AF.hell}" stroke="${AF.blau}" stroke-width="1.5"/>
      ${aText(x + b / 2, y + h / 2 + 5, esc(text), `font:600 13px Gabarito,sans-serif;fill:${AF.blau}`, 'text-anchor="middle"')}
    </g>`;
  }

  /** Der Knopf «Auf Social Media teilen» unter dem Rechner, wie in der Vorlage. */
  function aTeilenKnopf(T) {
    const k = ATEILEN_KNOPF;
    return `<g class="anl-teilen-knopf">
      <rect x="${k.x}" y="${k.y}" width="240" height="${k.h}" rx="8" fill="${AF.rot}"/>
      ${aText(k.x + 22, k.y + 28, esc(T.teilen), `font:600 15px Gabarito,sans-serif;fill:${AF.hell}`, 'class="anl-teilen-knopf-text"')}
      <g class="anl-teilen-symbol" fill="none" stroke="${AF.hell}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
        <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/>
      </g>
    </g>`;
  }

  /** Das Teilen-Fenster wie teilenDialog(), mit Abdunklung über der Bühne.
      Gibt das Markup und die Ziele für den Zeiger zurück. */
  function aTeilenFenster(T, breite, nativ) {
    const TT = teilenTexte();
    const ablageGeht = !!(navigator.clipboard && window.ClipboardItem);
    const P = AFENSTER_B, innen = P - 48;
    const zeichen = Math.floor(innen / 6.2);
    const KLEIN = `font:400 12px Gabarito,sans-serif;fill:${AF.blau};fill-opacity:.8`;
    const vorschau = { x: 24, y: 80, b: innen, h: 170 };
    const bildB = Math.round(vorschau.h * 1080 / 1350);
    let teil, hoehe, ziel;
    if (nativ) {
      teil = `<rect class="anl-bild-teilen" x="24" y="266" width="${innen}" height="40" rx="8" fill="${AF.rot}"/>
        ${aText(P / 2, 291, esc(TT.bildTeilen), `font:600 14px Gabarito,sans-serif;fill:${AF.hell}`, 'text-anchor="middle"')}
        ${aUmbruch(TT.nativ, 24, 330, zeichen, 16, KLEIN)}
        ${aLinienKnopf(24, 362, innen, 36, TT.nurSpeichern)}`;
      hoehe = 422;
      ziel = { x: P / 2, y: 286 };
    } else {
      const n = PLATTFORMEN.length, abstand = 8;
      const kb = (innen - (n - 1) * abstand) / n;
      const insta = Math.max(0, PLATTFORMEN.findIndex(p => p.schluessel === 'instagram'));
      const plattform = PLATTFORMEN[insta].name;
      teil = `${aUmbruch(ablageGeht ? TT.ablage : TT.speichern, 24, 272, zeichen, 16, KLEIN)}
        ${PLATTFORMEN.map((p, i) => aLinienKnopf(24 + i * (kb + abstand), 322, kb, 36, p.name, i === insta ? 'anl-plattform' : '')).join('')}
        ${aLinienKnopf(24, 366, innen, 36, TT.nurSpeichern)}
        ${aUmbruch(ablageGeht ? TT.inAblage(plattform) : TT.nurGespeichert(plattform), 24, 424, zeichen - 2, 16,
          `font:600 12px Gabarito,sans-serif;fill:${AF.rot}`, 'class="anl-teilen-hinweis" opacity="0"')}`;
      hoehe = 466;
      ziel = { x: 24 + insta * (kb + abstand) + kb / 2, y: 340 };
    }
    const px = (breite - P) / 2, py = Math.round((AH - hoehe) / 2);
    const markup = `<g class="anl-teilen">
      <rect class="anl-dimm" width="${breite}" height="${AH}" rx="14" fill="#211F1D" fill-opacity=".55" opacity="0"/>
      <g transform="translate(${px} ${py})"><g class="anl-teilen-fenster" opacity="0">
        <rect width="${P}" height="${hoehe}" rx="16" fill="${AF.hell}"/>
        ${aText(P - 22, 30, '✕', `font:400 14px Gabarito,sans-serif;fill:${AF.blau};fill-opacity:.55`, 'text-anchor="middle"')}
        ${aText(24, 36, esc(TT.eyebrow.toLocaleUpperCase('de-CH')), `font:700 10.5px Gabarito,sans-serif;letter-spacing:1.3px;fill:${AF.rot}`)}
        ${aText(24, 64, esc(TT.titel), `font:800 20px Gabarito,sans-serif;letter-spacing:-.3px;fill:${AF.blau}`)}
        <rect x="${vorschau.x}" y="${vorschau.y}" width="${vorschau.b}" height="${vorschau.h}" rx="10" fill="${AF.blau}"/>
        <image class="anl-teilbild" x="${vorschau.x + (vorschau.b - bildB) / 2}" y="${vorschau.y}" width="${bildB}" height="${vorschau.h}" preserveAspectRatio="xMidYMid meet"/>
        ${teil}
      </g></g>
      ${nativ ? `<g transform="translate(${(breite - 300) / 2} ${AH - 150})"><g class="anl-menue">
        <rect width="300" height="170" rx="16" fill="#fff" style="filter:drop-shadow(0 -6px 18px rgba(0,0,0,.18))"/>
        <rect x="130" y="9" width="40" height="4" rx="2" fill="${AF.blau}" fill-opacity=".2"/>
        ${[0, 1, 2, 3].map(i => `<circle cx="${42 + i * 72}" cy="58" r="22" fill="${AF.blau}" fill-opacity="${i ? .12 : .22}"/>
          <rect x="${24 + i * 72}" y="90" width="36" height="6" rx="3" fill="${AF.blau}" fill-opacity=".14"/>`).join('')}
      </g></g>` : ''}
    </g>`;
    return { markup, ziel: { x: px + ziel.x, y: py + ziel.y }, menue: { x: (breite - 300) / 2 + 42, y: AH - 150 + 58 } };
  }

  function zeichneAnleitung(T, szenario, quer, nativ) {
    const { tag } = szenario;
    const breite = quer ? AB_QUER : AB;
    const startIndex = 0;   // die echte Auswahl beginnt beim ersten Getränk

    // Was im geschlossenen Select steht: zuerst die Vorauswahl, dann je Getränk.
    const auswahlTexte = [startIndex].concat(tag.map(c => c.getraenkIndex));
    const selectTexte = auswahlTexte.map((i, n) =>
      aText(40, 80, esc(optionText(i)), `font:500 15px Gabarito,sans-serif;fill:${AF.blau}`,
        `class="anl-wahl" data-n="${n}" data-max="372"${n ? ' opacity="0"' : ''}`)).join('');
    const hinweisTexte = auswahlTexte.map((i, n) =>
      aText(24, 120, esc(GETRAENKE[i].hinweis || ''), `font:400 12.5px Gabarito,sans-serif;fill:${AF.blau};fill-opacity:.7`,
        `class="anl-hinweis" data-n="${n}" data-max="430"${n ? ' opacity="0"' : ''}`)).join('');

    const optionen = GETRAENKE.map((g, i) =>
      aText(36, ALISTE_Y + 4 + i * AOPTION + 17, esc(optionText(i)),
        `font:500 12.5px Gabarito,sans-serif;fill:${AF.blau}`, 'data-max="404"')).join('');

    const zeiger = window.matchMedia && window.matchMedia('(pointer: coarse)').matches
      // Finger: ein Punkt, die Spitze ist die Mitte.
      ? `<g class="anl-zeiger-koerper"><circle r="13" fill="${AF.blau}" fill-opacity=".22" stroke="${AF.blau}" stroke-width="2"/><circle r="3.5" fill="${AF.blau}"/></g>`
      // Maus: ein Pfeil, die Spitze ist 0/0.
      : `<g class="anl-zeiger-koerper"><path d="M0 0 L0 21 L5.6 15.6 L9.6 24.4 L13 22.9 L9 14.2 L16.4 14.2 Z" fill="${AF.blau}" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></g>`;

    const teilen = aTeilenFenster(T, breite, nativ);

    return `<svg class="anleitung-svg" viewBox="0 0 ${breite} ${AH}" role="presentation" focusable="false"
        style="font-family:Gabarito,sans-serif" data-ziel-x="${teilen.ziel.x}" data-ziel-y="${teilen.ziel.y}"
        data-menue-x="${teilen.menue.x}" data-menue-y="${teilen.menue.y}">
      <rect width="${breite}" height="${AH}" rx="14" fill="${AF.hell}"/>
      <g class="anl-inhalt">
      <!-- Die Seite, sie scrollt im letzten Kapitel hoch zum Teilen-Knopf -->
      <g class="anl-seite">

        <!-- Was hast Du getrunken? -->
        ${aLabel(36, T.getrunken)}
        <rect x="24" y="50" width="432" height="48" rx="8" fill="#fff" stroke="${AF.rand}" stroke-width="1.5" class="anl-select"/>
        ${selectTexte}
        <path d="M432 71 l5 5 l5 -5" fill="none" stroke="${AF.blau}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        ${hinweisTexte}

        <!-- Um wie viel Uhr? -->
        ${aLabel(160, T.uhrzeit, { aktuell: T.aktuell, uhr: uhrText(T.zeitStart) }, 'anl-zeit-wert')}
        ${aRegler(AREGLER.zeit, T.zeitStart, 'anl-zeit', T.zeitBereich)}

        <!-- Hinzufügen -->
        <g class="anl-knopf">
          <rect x="${AKNOPF.x}" y="${AKNOPF.y}" width="150" height="${AKNOPF.h}" rx="8" fill="${AF.rot}"/>
          ${aText(AKNOPF.x + 22, AKNOPF.y + 28, esc(T.hinzufuegen), `font:600 15px Gabarito,sans-serif;fill:${AF.hell}`, 'class="anl-knopf-text"')}
          <path class="anl-plus" d="M0 -6 V6 M-6 0 H6" stroke="${AF.hell}" stroke-width="1.8" stroke-linecap="round"/>
        </g>

        <!-- Wann gehst Du schlafen? -->
        ${aLabel(310, T.schlafen, { aktuell: T.aktuell, uhr: uhrText(T.schlafStart) }, 'anl-schlaf-wert')}
        ${aRegler(AREGLER.schlaf, T.schlafStart, 'anl-schlaf', T.schlafBereich)}

        <!-- Dein Tag -->
        ${aLabel(398, T.tag)}
        <g transform="translate(0 ${AZEILEN_Y})">
          ${aText(24, 28, esc(T.leer), `font:400 14px Gabarito,sans-serif;fill:${AF.blau};fill-opacity:.6`, 'class="anl-leer" opacity="0"')}
          ${BEISPIELTAG.map((c, i) => aZeile(c, 'anl-beispiel', i)).join('')}
          ${tag.map((c, i) => aZeile(c, 'anl-neu', i)).join('')}
        </g>

        <!-- Ergebnis: quer die Box rechts, hoch die Karte am Schluss -->
        ${quer ? aErgebnisBox(T, szenario) : ''}

        <!-- Offene Auswahl -->
        <g class="anl-liste" opacity="0">
          <rect x="24" y="${ALISTE_Y}" width="432" height="${GETRAENKE.length * AOPTION + 8}" rx="8" fill="#fff"
                stroke="${AF.rand}" stroke-width="1.2" style="filter:drop-shadow(0 8px 18px rgba(0,75,92,.18))"/>
          <rect class="anl-markiert" x="28" y="${ALISTE_Y + 4}" width="424" height="${AOPTION}" rx="5" fill="${AF.rot}" fill-opacity=".14"/>
          ${optionen}
        </g>

        ${quer ? '' : aErgebnisKarte(T, szenario)}

        <!-- Sprechblasen -->
        ${aBlase('anl-blase-loeschen', tx('anleitung_blase_loeschen', 'Erst die Beispiele löschen'), 446, AZEILEN_Y + 12, 'unten', 'ende')}
        ${aBlase('anl-blase-cappuccino', tx('anleitung_blase_cappuccino', 'Cappuccino = einfacher Espresso'), 352, 48, 'unten', 'mitte')}
        ${tag.map((c) => aBlase('anl-blase-runden', tx('anleitung_blase_runden', '{uhr} → {stunde}', { uhr: c.uhr, stunde: uhrText(c.stunde) }), 0, 152, 'links', 'start')).join('')}
        ${aBlase('anl-blase-schlaf', tx('anleitung_blase_schlaf', 'Schlafenszeit einstellen'), 0, 304, 'links', 'start')}
        ${quer ? aBlase('anl-blase-ergebnis', tx('anleitung_blase_ergebnis', 'Hier steht Dein Ergebnis'), 0, ABOX.y + 128, 'links', 'start', AF.rot) : ''}

        <!-- Unter dem Rechner -->
        ${aTeilenKnopf(T)}
      </g>

        <!-- Teilen-Fenster -->
        ${teilen.markup}
        ${nativ ? aBlase('anl-blase-app', tx('anleitung_blase_app', 'App wählen, zum Beispiel Instagram'), teilen.menue.x, teilen.menue.y - 30, 'unten', 'start') : ''}

        <circle class="anl-ring" r="4" fill="none" stroke="${AF.rot}" stroke-width="2.5" opacity="0"/>
        <g class="anl-zeiger" transform="translate(${AB - 10} ${AH + 30})">${zeiger}</g>
      </g>
    </svg>`;
  }

  /** Kürzt zu lange Texte mit … und passt die Sprechblasen an ihren Text an.
      Läuft nach dem Einsetzen und noch einmal, wenn die Schrift geladen ist. */
  function anleitungVermessen(svg) {
    svg.querySelectorAll('text[data-max]').forEach((t) => {
      if (!t.dataset.voll) t.dataset.voll = t.textContent;
      t.textContent = t.dataset.voll;
      const max = +t.dataset.max;
      let s = t.dataset.voll;
      while (s.length > 1 && t.getComputedTextLength() > max) {
        s = s.slice(0, -1);
        t.textContent = s.trimEnd() + '…';
      }
    });

    svg.querySelectorAll('.anl-blase').forEach((g) => {
      const text = g.querySelector('text');
      const rect = g.querySelector('rect');
      const pfeil = g.querySelector('path');
      const b = Math.ceil(text.getComputedTextLength()) + 24, h = 28;
      const anker = g.dataset.anker, richtung = g.dataset.richtung;
      let x, y, spitze;
      if (richtung === 'links') {
        x = 10; y = -h / 2;
        spitze = 'M10 -6 L0 0 L10 6 Z';
      } else {
        x = anker === 'ende' ? 18 - b : (anker === 'start' ? -18 : -b / 2);
        y = richtung === 'unten' ? -10 - h : 10;
        spitze = richtung === 'unten' ? 'M-7 -10.5 L0 0 L7 -10.5 Z' : 'M-7 10.5 L0 0 L7 10.5 Z';
      }
      rect.setAttribute('x', x); rect.setAttribute('y', y); rect.setAttribute('width', b);
      text.setAttribute('x', x + 12); text.setAttribute('y', y + 19);
      pfeil.setAttribute('d', spitze);
    });

    // Blasen rechts neben einem Text: an den Reglern neben «Aktuell 08:00»,
    // quer neben der grossen Zahl der Ergebnisbox (mit Platz für drei Ziffern).
    [['.anl-zeit-wert', '.anl-blase-runden', 154, 0], ['.anl-schlaf-wert', '.anl-blase-schlaf', 304, 0],
     ['.anl-box-zahltext', '.anl-blase-ergebnis', ABOX.y + 128, ABOX.x + 30]].forEach(([wert, blase, y, dx]) => {
      const el = svg.querySelector(wert);
      if (!el) return;
      const ziel = wert === '.anl-box-zahltext' ? el : el.parentNode;
      const kasten = ziel.getBBox();
      svg.querySelectorAll(blase).forEach((g) =>
        g.setAttribute('transform', `translate(${Math.ceil(dx + kasten.x + kasten.width) + 8} ${y})`));
    });

    // Teilen-Knopf so breit wie sein Text, Symbol dahinter (24er-Raster, 0,75).
    const teilenText = svg.querySelector('.anl-teilen-knopf-text');
    if (teilenText) {
      const tb = Math.ceil(teilenText.getComputedTextLength());
      svg.querySelector('.anl-teilen-knopf rect').setAttribute('width', 22 + tb + 12 + 18 + 22);
      svg.querySelector('.anl-teilen-symbol').setAttribute('transform',
        `translate(${ATEILEN_KNOPF.x + 22 + tb + 12} ${ATEILEN_KNOPF.y + ATEILEN_KNOPF.h / 2 - 9}) scale(.75)`);
    }

    // Plus im Knopf hinter den Text, Knopf so breit wie sein Inhalt.
    const knopfText = svg.querySelector('.anl-knopf-text');
    const breite = Math.ceil(knopfText.getComputedTextLength());
    svg.querySelector('.anl-knopf rect').setAttribute('width', breite + 22 + 12 + 14 + 22);
    svg.querySelector('.anl-plus').setAttribute('transform',
      `translate(${AKNOPF.x + 22 + breite + 12 + 7} ${AKNOPF.y + AKNOPF.h / 2})`);
  }

  /* --- Ablauf --------------------------------------------------------------- */

  /** Baut die Zeitleiste zur Zeichnung. Gibt sie zurück, dazu sync(), das
      Uhrzeit und Zahlen aus den Stellvertretern in die Zeichnung schreibt. */
  function anleitungZeitleiste(svg, T, szenario, quer, nativ) {
    const $ = (s) => svg.querySelector(s);
    const $$ = (s) => Array.from(svg.querySelectorAll(s));
    const { tag, rest, zustaende } = szenario;

    const inhalt = $('.anl-inhalt');
    const zeiger = $('.anl-zeiger');
    const koerper = $('.anl-zeiger-koerper');
    const ring = $('.anl-ring');
    const listeOffen = $('.anl-liste');
    const markiert = $('.anl-markiert');
    const beispiele = $$('.anl-beispiel');
    const neue = $$('.anl-neu');
    const wahl = $$('.anl-wahl');
    const hinweise = $$('.anl-hinweis');
    const runden = $$('.anl-blase-runden');
    const zeitDaumen = $('.anl-zeit .anl-daumen'), zeitFuell = $('.anl-zeit .anl-fuell');
    const zeitWert = $('.anl-zeit-wert');
    const knopf = $('.anl-knopf');

    // Startzustand, auf den die Zeitleiste beim Zurückspulen zurückfällt.
    // Uhrzeit und Zahlen hängen an Stellvertretern, die sync() schreibt.
    const stand = { zeit: T.zeitStart, mg: quer ? zustaende[0].rest : 0, summe: zustaende[0].summe };
    gsap.set(zeiger, { x: AB - 10, y: AH + 30 });
    beispiele.forEach((z, i) => gsap.set(z, { y: i * AZEILE }));
    neue.forEach((z, i) => gsap.set(z, { y: i * AZEILE, x: -14, opacity: 0 }));
    gsap.set($$('.anl-blase'), { opacity: 0 });

    // Kurven zeichnen sich über die Strichlänge.
    const strich = (pfad, sichtbar) => {
      const l = pfad.getTotalLength();
      gsap.set(pfad, { strokeDasharray: l, strokeDashoffset: sichtbar ? 0 : l });
      return l;
    };

    const tl = gsap.timeline({ paused: true, repeat: -1, defaults: { ease: 'bw-weich', immediateRender: false } });
    // Läuft, wenn der Leser sie startet; die Tempo-Stufen halten sie nie an.
    if (window.BW && window.BW.tempoAusnahme) window.BW.tempoAusnahme(tl);
    const K = ANLEITUNG.kapitel;
    K.forEach((t, i) => tl.addLabel('k' + i, t));

    const optionY = (i) => ALISTE_Y + 4 + i * AOPTION;
    const zeitX = (h) => reglerX(AREGLER.zeit, h);
    const zeilenX = { x: 446, y: AZEILEN_Y + 23 };            // ✕ der obersten Zeile
    const knopfMitte = { x: AKNOPF.x + 60, y: AKNOPF.y + AKNOPF.h / 2 };

    const fahren = (t, x, y, d = 0.8) => tl.to(zeiger, { x, y, duration: d }, t);
    const klick = (t, x, y) => {
      tl.set(ring, { attr: { cx: x, cy: y } }, t)
        .fromTo(ring, { attr: { r: 4 }, opacity: 0.95 }, { attr: { r: 24 }, opacity: 0, duration: 0.5, ease: 'power2.out' }, t)
        .to(koerper, { scale: 0.84, transformOrigin: '50% 50%', duration: 0.09, yoyo: true, repeat: 1, ease: 'power1.inOut' }, t);
    };
    const zeigen = (el, t, d = 0.3) => tl.fromTo(el, { opacity: 0 }, { opacity: 1, duration: d, ease: 'bw-aus' }, t);
    const blaseAn = (el, t) => tl.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 0.3, ease: 'bw-aus' }, t);
    const blaseAus = (el, t) => tl.to(el, { opacity: 0, duration: 0.25, ease: 'power1.out' }, t);
    const umschalten = (els, n, t) => els.forEach((el, i) => tl.set(el, { opacity: i === n ? 1 : 0 }, t));

    /* quer: Die Ergebnisbox wechselt zum Stand n, wie die echte nach jeder
       Eingabe: Zahl und Summe zählen, der Balken wächst, die Kurve zeichnet
       sich neu. */
    const staende = quer ? $$('.anl-stand') : [];
    const standLaengen = staende.map((g, n) => strich(g.querySelector('.anl-kurve'), n === 0));
    staende.forEach((g, n) => gsap.set(g, { opacity: n === 0 ? 1 : 0 }));
    if (quer) gsap.set(staende[0].querySelector('.anl-flaeche'), { opacity: 0.22 });
    const boxBalken = $('.anl-box-balken');
    const boxBreite = ABOX.b - 2 * 28;
    function standWechsel(t, n) {
      if (!quer) return;
      const z = zustaende[n];
      umschalten(staende, n, t);
      tl.fromTo(staende[n].querySelector('.anl-kurve'), { strokeDashoffset: standLaengen[n] },
        { strokeDashoffset: 0, duration: 0.9, ease: 'power2.out' }, t)
        .fromTo(staende[n].querySelector('.anl-flaeche'), { opacity: 0 }, { opacity: 0.22, duration: 0.7, ease: 'power2.out' }, t)
        .to(stand, { mg: z.rest, summe: z.summe, duration: 0.7, ease: 'power2.out' }, t)
        .set(boxBalken, { attr: { fill: z.rest > SCHLAFGRENZE ? AF.rot : AF.cyan } }, t)
        .to(boxBalken, { attr: { width: boxBreite * Math.min(1, z.rest / 200) }, duration: 0.7, ease: 'bw-aus' }, t);
    }

    /** Auswahl öffnen, Getränk wählen, schliessen. Gibt die Zeit danach zurück. */
    function waehlen(t, vonIndex, nachIndex) {
      fahren(t, 300, 74, 0.7);
      klick(t + 0.75, 300, 74);
      tl.set(markiert, { attr: { y: optionY(vonIndex) } }, t + 0.8)
        .fromTo(listeOffen, { opacity: 0, y: -6 }, { opacity: 1, y: 0, duration: 0.25, ease: 'bw-aus' }, t + 0.8);
      const ty = optionY(nachIndex) + AOPTION / 2;
      fahren(t + 1.1, 220, ty, 0.6);
      tl.to(markiert, { attr: { y: optionY(nachIndex) }, duration: 0.6 }, t + 1.1);
      return t + 1.8;
    }
    function bestaetigen(t, nachIndex, n) {
      klick(t, 220, optionY(nachIndex) + AOPTION / 2);
      tl.to(listeOffen, { opacity: 0, duration: 0.2, ease: 'power1.out' }, t + 0.15);
      umschalten(wahl, n, t + 0.2);
      umschalten(hinweise, n, t + 0.2);
    }
    function regeln(t, von, nach, d) {
      fahren(t, zeitX(von), AREGLER.zeit.y, 0.6);
      if (von === nach) return t + 0.6;
      const dauer = d || 0.3 + Math.abs(nach - von) * 0.11;
      fahren(t + 0.7, zeitX(nach), AREGLER.zeit.y, dauer);
      tl.to(stand, { zeit: nach, duration: dauer }, t + 0.7)
        .to(zeitDaumen, { attr: { cx: zeitX(nach) }, duration: dauer }, t + 0.7)
        .to(zeitFuell, { attr: { width: zeitX(nach) - AREGLER.zeit.x }, duration: dauer }, t + 0.7);
      return t + 0.7 + dauer;
    }
    function hinzufuegen(t, i) {
      fahren(t, knopfMitte.x, knopfMitte.y, 0.55);
      klick(t + 0.6, knopfMitte.x, knopfMitte.y);
      tl.to(knopf, { scale: 0.96, transformOrigin: '50% 50%', duration: 0.1, yoyo: true, repeat: 1 }, t + 0.6)
        .to(neue[i], { opacity: 1, x: 0, duration: 0.45, ease: 'bw-aus' }, t + 0.75);
      if (i === 0) tl.to($('.anl-leer'), { opacity: 0, duration: 0.2 }, t + 0.7);
      standWechsel(t + 0.75, BEISPIELTAG.length + 1 + i);
    }

    // Kapitel 1 · Beispiele löschen
    tl.fromTo(inhalt, { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'power1.out' }, 0);
    blaseAn($('.anl-blase-loeschen'), 0.4);
    fahren(0.6, zeilenX.x, zeilenX.y, 1.0);
    beispiele.forEach((z, i) => {
      const t = 1.7 + i * 0.9;
      klick(t, zeilenX.x, zeilenX.y);
      tl.to(z, { opacity: 0, x: 14, duration: 0.25, ease: 'power1.in' }, t + 0.05);
      beispiele.slice(i + 1).forEach((z2, j) => tl.to(z2, { y: j * AZEILE, duration: 0.35, ease: 'bw-aus' }, t + 0.3));
      standWechsel(t + 0.15, i + 1);
    });
    blaseAus($('.anl-blase-loeschen'), 3.9);
    zeigen($('.anl-leer'), 4.1, 0.35);

    // Kapitel 2 bis 4 · je ein Getränk
    let vorher = 0, zeitVorher = T.zeitStart;
    tag.forEach((c, i) => {
      const t0 = K[i + 1];
      let t = waehlen(t0, vorher, c.getraenkIndex);
      if (i === 0) blaseAn($('.anl-blase-cappuccino'), t0 + 1.4);
      bestaetigen(t, c.getraenkIndex, i + 1);
      if (i === 0) blaseAus($('.anl-blase-cappuccino'), t + 0.3);
      t = regeln(t + 0.45, zeitVorher, c.stunde);
      // Gerundet wird nur, wo die echte Uhrzeit keine volle Stunde ist.
      const blase = runden[i];
      const gerundet = c.uhr.split(':')[1] !== '00';
      if (gerundet) blaseAn(blase, t + 0.05);
      hinzufuegen(t + 0.5, i);
      // Die Blase bleibt zum Lesen stehen, aber nie bis in die nächste Auswahl.
      if (gerundet) blaseAus(blase, Math.min(t + 2.4, K[i + 2] - 0.1));
      vorher = c.getraenkIndex;
      zeitVorher = c.stunde;
    });

    // Kapitel 5 · Ergebnis ablesen
    const t5 = K[4];
    const schlafX = reglerX(AREGLER.schlaf, T.schlafStart);
    fahren(t5, schlafX, AREGLER.schlaf.y, 0.8);
    klick(t5 + 0.85, schlafX, AREGLER.schlaf.y);
    blaseAn($('.anl-blase-schlaf'), t5 + 0.6);
    blaseAus($('.anl-blase-schlaf'), t5 + 1.9);
    if (quer) {
      // Die Box steht schon da: Der Zeiger zeigt auf die Zahl.
      const zahl = $('.anl-box-zahltext');
      fahren(t5 + 1.6, ABOX.x + 34, ABOX.y + 156, 0.9);
      blaseAn($('.anl-blase-ergebnis'), t5 + 2.4);
      blaseAus($('.anl-blase-ergebnis'), K[5] - 0.2);
      tl.to(zahl, { scale: 1.08, transformOrigin: '0% 100%', duration: 0.35, yoyo: true, repeat: 1, ease: 'power1.inOut' }, t5 + 2.5)
        .to(zeiger, { opacity: 0, duration: 0.4, ease: 'power1.out' }, t5 + 2.7);
    } else {
      const ergebnis = $('.anl-ergebnis');
      const kurve = ergebnis.querySelector('.anl-kurve');
      gsap.set(ergebnis, { y: -24 });
      strich(kurve, false);
      fahren(t5 + 1.3, AB - 60, AH - 20, 0.9);
      tl.to(zeiger, { opacity: 0, duration: 0.4, ease: 'power1.out' }, t5 + 1.8)
        .to(ergebnis, { opacity: 1, y: 0, duration: 0.6, ease: 'bw-aus' }, t5 + 1.4)
        .to(stand, { mg: rest, duration: 1.3, ease: 'power2.out' }, t5 + 1.8)
        .to($('.anl-balken'), { attr: { width: +$('.anl-balken').dataset.ziel }, duration: 1.0, ease: 'bw-aus' }, t5 + 1.9)
        .to(kurve, { strokeDashoffset: 0, duration: 1.5, ease: 'power2.out' }, t5 + 1.9)
        .to(ergebnis.querySelector('.anl-flaeche'), { opacity: 0.22, duration: 0.8, ease: 'power2.out' }, t5 + 2.4)
        .to(ergebnis.querySelectorAll('.anl-marke'), { opacity: 1, duration: 0.35, stagger: 0.12, ease: 'bw-aus' }, t5 + 2.8);
    }
    // Kapitel 6 · Ergebnis teilen: Die Seite scrollt zum Knopf unter dem
    // Rechner, das Teilen-Fenster geht auf, dann je nach Gerät Instagram
    // (Zwischenablage) oder «Bild teilen» (Teilen-Menü).
    const t6 = K[5];
    const seite = $('.anl-seite');
    const teilenKnopf = $('.anl-teilen-knopf');
    const fensterTeilen = $('.anl-teilen-fenster');
    const knopfZiel = { x: ATEILEN_KNOPF.x + 110, y: ATEILEN_KNOPF.y + ATEILEN_KNOPF.h / 2 - ASCROLL };
    const ziel = { x: +svg.dataset.zielX, y: +svg.dataset.zielY };
    gsap.set(fensterTeilen, { y: 20 });
    tl.to(zeiger, { opacity: 1, duration: 0.3, ease: 'power1.out' }, t6)
      .to(seite, { y: -ASCROLL, duration: 0.8 }, t6);
    fahren(t6 + 0.3, knopfZiel.x, knopfZiel.y, 0.9);
    klick(t6 + 1.3, knopfZiel.x, knopfZiel.y);
    tl.to(teilenKnopf, { scale: 0.96, transformOrigin: '50% 50%', duration: 0.1, yoyo: true, repeat: 1 }, t6 + 1.3)
      .to($('.anl-dimm'), { opacity: 1, duration: 0.3, ease: 'power1.out' }, t6 + 1.5)
      .to(fensterTeilen, { opacity: 1, y: 0, duration: 0.45, ease: 'bw-aus' }, t6 + 1.5);
    fahren(t6 + 2.3, ziel.x, ziel.y, 0.8);
    klick(t6 + 3.2, ziel.x, ziel.y);
    if (nativ) {
      const menue = $('.anl-menue');
      gsap.set(menue, { y: 190 });
      tl.to($('.anl-bild-teilen'), { attr: { fill: AF.blau }, duration: 0.15 }, t6 + 3.2)
        .to(menue, { y: 0, duration: 0.5, ease: 'bw-aus' }, t6 + 3.4);
      fahren(t6 + 3.9, +svg.dataset.menueX, +svg.dataset.menueY, 0.7);
      blaseAn($('.anl-blase-app'), t6 + 4.1);
    } else {
      const plattform = $('.anl-plattform');
      tl.to(plattform.querySelector('rect'), { attr: { fill: AF.blau }, duration: 0.15 }, t6 + 3.2)
        .to(plattform.querySelector('text'), { fill: AF.hell, duration: 0.15 }, t6 + 3.2);
      zeigen($('.anl-teilen-hinweis'), t6 + 3.4, 0.35);
    }

    tl.to(inhalt, { opacity: 0, duration: 0.5, ease: 'power1.in' }, ANLEITUNG.dauer - 0.7)
      .to({}, { duration: 0.01 }, ANLEITUNG.dauer - 0.01);    // genau so lang wie dauer

    const zahl = $(quer ? '.anl-box-zahl' : '.anl-zahl');
    const summe = $('.anl-box-summe');
    function sync() {
      zeitWert.textContent = uhrText(Math.round(stand.zeit));
      zahl.textContent = Math.round(stand.mg);
      if (summe) summe.textContent = Math.round(stand.summe);
    }
    return { tl, sync };
  }

  /* --- Knopf und Popup ------------------------------------------------------ */

  function koffeinAnleitung() {
    const platz = document.getElementById('koffein-anleitung');
    if (!platz || !window.gsap) return;

    platz.hidden = false;
    platz.innerHTML = `<button type="button" class="btn btn--linie anleitung-oeffnen" aria-haspopup="dialog">
        <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3.5 1.8v10.4L12 7z" fill="currentColor"/></svg>
        <span>${esc(tx('anleitung_knopf', 'Anleitung'))}</span>
      </button>`;
    const knopf = platz.querySelector('.anleitung-oeffnen');
    knopf.addEventListener('click', () => anleitungOeffnen(knopf));
  }

  function anleitungOeffnen(ausloeser) {
    if (document.getElementById('anleitung-dialog')) return;

    const T = rechnerTexte();
    const szenario = anleitungSzenario();
    // Teilen läuft wie im echten Fenster: Teilen-Menü oder Zwischenablage.
    const nativ = kannNativTeilen();
    const schritte = anleitungSchritte(T, szenario.rest, nativ);
    const K = ANLEITUNG.kapitel;
    const format = window.matchMedia(ANLEITUNG.quer);

    // Gebaut wie das Teilen-Fenster: gleicher Hintergrund, gleiches ✕.
    const dialog = document.createElement('div');
    dialog.id = 'anleitung-dialog';
    dialog.className = 'teilen-dialog anleitung-dialog';
    dialog.innerHTML = `
      <div class="anleitung-fenster" role="dialog" aria-modal="true" aria-labelledby="anleitung-titel">
        <button type="button" class="teilen-zu" aria-label="${esc(tx('schliessen', 'Schliessen'))}">✕</button>
        <div class="anleitung-kopf">
          <span class="eyebrow">${esc(tx('anleitung_eyebrow', 'So geht’s · {sekunden} Sekunden', { sekunden: ANLEITUNG.dauer }))}</span>
          <p class="anleitung-titel" id="anleitung-titel">${esc(tx('anleitung_titel', 'So trägst Du Deinen Tag ein.'))}</p>
        </div>
        <div class="anleitung-buehne" aria-hidden="true"></div>
        <div class="anleitung-steuerung">
          <ol class="anleitung-schritte">
            ${schritte.map((s, i) => `<li>
              <button type="button" class="anleitung-schritt" data-kapitel="${i}">
                <span class="nr">${i + 1}</span>
                <span class="was"><strong>${esc(s.kurz)}</strong><span class="text">${esc(s.text)}</span></span>
                <span class="fortschritt" aria-hidden="true"><span></span></span>
              </button>
            </li>`).join('')}
          </ol>
          <button type="button" class="anleitung-knopf">
            <svg class="ic-pause" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3.5 2v10M10.5 2v10" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>
            <svg class="ic-spielen" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3.5 1.8v10.4L12 7z" fill="currentColor"/></svg>
            <span class="beschriftung">${esc(tx('anleitung_pause', 'Pause'))}</span>
          </button>
        </div>
        <p class="anleitung-untertitel" aria-hidden="true"><strong></strong><span></span></p>
      </div>`;
    document.body.appendChild(dialog);

    const fenster = dialog.querySelector('.anleitung-fenster');
    const buehne = dialog.querySelector('.anleitung-buehne');
    const zu = dialog.querySelector('.teilen-zu');
    const knoepfe = Array.from(dialog.querySelectorAll('.anleitung-schritt'));
    const balken = knoepfe.map(k => k.querySelector('.fortschritt span'));
    const pause = dialog.querySelector('.anleitung-knopf');
    const untertitel = dialog.querySelector('.anleitung-untertitel');

    // Die Seite dahinter bleibt stehen, solange das Popup offen ist.
    const html = document.documentElement;
    const ueberlaufVorher = html.style.overflow;
    html.style.overflow = 'hidden';

    // Das echte Teilbild des Beispieltags, verkleinert für die Vorschau im
    // Teilen-Fenster. Es kommt asynchron, gebraucht wird es erst im 6. Kapitel.
    let teilbild = null;
    function teilbildSetzen() {
      const bild = buehne.querySelector('.anl-teilbild');
      if (bild && teilbild) bild.setAttribute('href', teilbild);
    }
    zeichneTeilenBild(szenario.liste, ANLEITUNG.schlaf).then((gross) => {
      const klein = document.createElement('canvas');
      klein.width = 324; klein.height = 405;
      klein.getContext('2d').drawImage(gross, 0, 0, klein.width, klein.height);
      teilbild = klein.toDataURL('image/png');
      teilbildSetzen();
    }).catch(() => { /* ohne Vorschau geht es auch */ });

    let lauf = null;                 // { tl, sync } der aktuellen Zeichnung
    let aktiv = -1;
    let angehalten = ruhig;          // vom Knopf, bei reduzierter Bewegung von Anfang an

    function sync() {
      if (!lauf) return;
      lauf.sync();
      const t = lauf.tl.time();
      let k = 0;
      while (k < K.length - 1 && t >= K[k + 1]) k++;
      if (k !== aktiv) {
        knoepfe.forEach((b, i) => {
          b.classList.toggle('ist-aktiv', i === k);
          b.classList.toggle('ist-fertig', i < k);
          if (i === k) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        });
        untertitel.firstChild.textContent = schritte[k].kurz;
        untertitel.lastChild.textContent = ' ' + schritte[k].text;
        aktiv = k;
      }
      const ende = k < K.length - 1 ? K[k + 1] : ANLEITUNG.dauer;
      balken.forEach((b, i) => {
        b.style.transform = `scaleX(${i < k ? 1 : i > k ? 0 : Math.min(1, (t - K[k]) / (ende - K[k]))})`;
      });
    }
    function knopfZeigen() {
      pause.classList.toggle('ist-angehalten', angehalten);
      pause.querySelector('.beschriftung').textContent = angehalten
        ? tx('anleitung_abspielen', 'Abspielen') : tx('anleitung_pause', 'Pause');
    }
    function laufen() {
      if (angehalten) lauf.tl.pause(); else lauf.tl.play();
      knopfZeigen();
    }
    function springen(zeit) {
      lauf.tl.seek(zeit, false);
      sync();
    }

    /** Zeichnung und Zeitleiste fürs aktuelle Format, weiter bei zeit. */
    function bauen(zeit) {
      if (lauf) lauf.tl.kill();
      const quer = format.matches;
      fenster.dataset.format = quer ? 'quer' : 'hoch';
      buehne.innerHTML = zeichneAnleitung(T, szenario, quer, nativ);
      const svg = buehne.querySelector('svg');
      anleitungVermessen(svg);
      teilbildSetzen();
      lauf = anleitungZeitleiste(svg, T, szenario, quer, nativ);
      lauf.tl.eventCallback('onUpdate', sync);
      dialog.bwZeitleiste = lauf.tl;   // für Tests: Kapitel ansteuern, ohne zu warten
      springen(zeit);
      laufen();
    }
    function formatWechsel() { bauen(lauf ? lauf.tl.time() : 0.4); }

    // Ohne Bewegung steht das fertige Bild, sonst beginnt sie bei 0,4 s:
    // Bei 0 wäre die Bühne leer, dort blendet erst die Schleife wieder ein.
    bauen(ruhig ? ANLEITUNG.dauer - 1 : 0.4);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => { const svg = buehne.querySelector('svg'); if (svg) anleitungVermessen(svg); });
    }
    if (format.addEventListener) format.addEventListener('change', formatWechsel);

    pause.addEventListener('click', () => { angehalten = !angehalten; laufen(); });
    knoepfe.forEach((b, i) => b.addEventListener('click', () => {
      if (ruhig && angehalten) {
        // Ohne Bewegung zeigt ein Schritt sein fertiges Bild, abgespielt wird nicht.
        springen((i < K.length - 1 ? K[i + 1] : ANLEITUNG.dauer) - 1);
        return;
      }
      springen(K[i] + 0.01);
      laufen();
    }));

    function schliessen() {
      if (format.removeEventListener) format.removeEventListener('change', formatWechsel);
      document.removeEventListener('keydown', taste);
      lauf.tl.kill();
      html.style.overflow = ueberlaufVorher;
      ausloeser.focus();
      if (ruhig) { dialog.remove(); return; }
      gsap.to(dialog, { opacity: 0, duration: 0.22, onComplete: () => dialog.remove() });
    }
    // Esc schliesst, Tab bleibt im Fenster.
    function taste(e) {
      if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
      if (e.key !== 'Tab') return;
      const ziele = Array.from(fenster.querySelectorAll('button'));
      const erstes = ziele[0], letztes = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    }
    zu.addEventListener('click', schliessen);
    dialog.addEventListener('click', (e) => { if (e.target === dialog) schliessen(); });
    document.addEventListener('keydown', taste);
    zu.focus();

    if (!ruhig) {
      gsap.from(dialog, { opacity: 0, duration: 0.25 });
      gsap.from(fenster, { y: 26, scale: 0.97, duration: 0.45, ease: 'bw-aus' });
    }
  }

  /* ======================================================================
     Teilbares Bild
     Zeichnet das Ergebnis als 1080 mal 1350 auf ein Canvas, also im Format,
     das der CI-Guide für Instagram und LinkedIn vorgibt. Bewusst selbst
     gezeichnet statt einen Screenshot der Box zu nehmen: So stimmen
     Schrift, Abstände und Farben, und das Bild bleibt scharf.
     ====================================================================== */

  const BILD_B = 1080, BILD_H = 1350;

  /* Sichere Zone.
     Im Feed zeigen Instagram und LinkedIn 4:5 vollständig. Im
     Instagram-Profilraster wird derselbe Beitrag aber mittig auf 1:1
     beschnitten, oben und unten fallen je 135 px weg. Alles, was gelesen
     werden muss, bleibt deshalb zwischen diesen beiden Linien. */
  const SICHER_OBEN = 150;
  const SICHER_UNTEN = 1215;

  function signetLaden() {
    return new Promise((fertig) => {
      const bild = new Image();
      bild.onload = () => fertig(bild);
      bild.onerror = () => fertig(null);
      bild.src = '//beanwatch.ch/cdn/shop/t/35/assets/logo-hellorange-signet.svg?v=82879766748971836661791269166';
    });
  }

  /** Text auf mehrere Zeilen umbrechen und zeichnen. Gibt die neue y-Position zurück. */
  function textBlock(ctx, text, x, y, maxBreite, zeilenHoehe) {
    const woerter = String(text).split(' ');
    let zeile = '';
    woerter.forEach((wort) => {
      const test = zeile ? zeile + ' ' + wort : wort;
      if (ctx.measureText(test).width > maxBreite && zeile) {
        ctx.fillText(zeile, x, y);
        y += zeilenHoehe;
        zeile = wort;
      } else {
        zeile = test;
      }
    });
    if (zeile) { ctx.fillText(zeile, x, y); y += zeilenHoehe; }
    return y;
  }

  /* liste und schlaf: ohne Angabe der eingetragene Tag, die Anleitung zeigt
     damit das Bild ihres Beispieltags. */
  async function zeichneTeilenBild(liste = konsum, schlaf = schlafenszeit) {
    const flaeche = document.createElement('canvas');
    flaeche.width = BILD_B;
    flaeche.height = BILD_H;
    const ctx = flaeche.getContext('2d');

    // Schrift muss geladen sein, sonst zeichnet Canvas die Ersatzschrift.
    if (document.fonts && document.fonts.ready) {
      try { await document.fonts.load('900 100px Gabarito'); await document.fonts.ready; } catch (e) { /* egal */ }
    }
    const signet = await signetLaden();

    const S = 'Gabarito, Trebuchet MS, sans-serif';
    const rest = mgZurZeit(schlaf, liste);
    const summe = gesamt(liste);
    const uhr = String(schlaf % 24).padStart(2, '0') + ':00';

    // Sortierte Einträge, sie werden mehrfach gebraucht.
    const eintraege = liste.slice().sort((a, b) => a.stunde - b.stunde);

    // --- Grund ---
    ctx.fillStyle = '#004B5C';
    ctx.fillRect(0, 0, BILD_B, BILD_H);

    // --- Kopfzeile ---
    // Sagt sofort, worum es geht. „Koffeinrechner“ allein weckt kein Interesse.
    ctx.fillStyle = '#4FC4E2';
    ctx.font = `700 30px ${S}`;
    ctx.letterSpacing = '4px';
    ctx.fillText(tx('bild_kopf', 'SO VIEL KOFFEIN HABE ICH IN MIR'), 80, SICHER_OBEN + 12);
    ctx.letterSpacing = '0px';

    if (signet) {
      try { ctx.drawImage(signet, BILD_B - 80 - 88, SICHER_OBEN - 62, 88, 90); } catch (e) { /* egal */ }
    }

    // --- Grosse Zahl ---
    ctx.fillStyle = '#FFF3E8';
    ctx.font = `900 180px ${S}`;
    const zahl = String(Math.round(rest));
    ctx.fillText(zahl, 80, 342);
    const zahlBreite = ctx.measureText(zahl).width;
    ctx.font = `800 60px ${S}`;
    ctx.fillStyle = 'rgba(255,243,232,.72)';
    ctx.fillText('mg', 80 + zahlBreite + 16, 342);

    ctx.font = `600 32px ${S}`;
    ctx.fillStyle = 'rgba(255,243,232,.88)';
    ctx.fillText(tx('bild_schlaf', 'nehme ich um {uhr} mit in den Schlaf', { uhr }), 80, 392);
    ctx.font = `500 28px ${S}`;
    ctx.fillStyle = 'rgba(255,243,232,.6)';
    ctx.fillText(tx('bild_insgesamt', 'von insgesamt {mg} mg an diesem Tag', { mg: Math.round(summe) }), 80, 432);

    // --- Kurve ---
    const kx = 80, ky = 480, kb = BILD_B - 160, kh = 268;
    const maxWert = Math.max(150, summe * 0.85);

    // Schlafgrenze
    const ySchwelle = ky + kh - (SCHLAFGRENZE / maxWert) * kh;
    ctx.strokeStyle = 'rgba(255,243,232,.34)';
    ctx.lineWidth = 2;
    ctx.setLineDash([8, 7]);
    ctx.beginPath(); ctx.moveTo(kx, ySchwelle); ctx.lineTo(kx + kb, ySchwelle); ctx.stroke();
    ctx.setLineDash([]);

    ctx.font = `600 21px ${S}`;
    const grenzText = tx('bild_grenze', '50 mg · Schlafgrenze');
    const grenzBreite = ctx.measureText(grenzText).width;
    ctx.fillStyle = '#004B5C';
    ctx.fillRect(kx + 2, ySchwelle - 32, grenzBreite + 16, 25);
    ctx.fillStyle = 'rgba(255,243,232,.8)';
    ctx.fillText(grenzText, kx + 10, ySchwelle - 14);

    // Fläche und Linie
    const punkte = [];
    for (let i = 0; i <= 120; i++) {
      const std = 5 + 21 * (i / 120);
      const w = mgZurZeit(std, liste);
      punkte.push([kx + (i / 120) * kb, ky + kh - Math.min(1, w / maxWert) * kh]);
    }
    ctx.beginPath();
    ctx.moveTo(punkte[0][0], ky + kh);
    punkte.forEach(p => ctx.lineTo(p[0], p[1]));
    ctx.lineTo(kx + kb, ky + kh);
    ctx.closePath();
    ctx.fillStyle = 'rgba(255,70,18,.38)';
    ctx.fill();

    ctx.beginPath();
    punkte.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
    ctx.strokeStyle = '#FF4612';
    ctx.lineWidth = 6;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.stroke();

    // Grundlinie
    ctx.strokeStyle = 'rgba(255,243,232,.3)';
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(kx, ky + kh); ctx.lineTo(kx + kb, ky + kh); ctx.stroke();

    // Schlafenszeit, mit Uhrzeit direkt darunter
    const xSchlaf = kx + ((schlaf - 5) / 21) * kb;
    ctx.strokeStyle = '#4FC4E2';
    ctx.setLineDash([7, 6]);
    ctx.beginPath(); ctx.moveTo(xSchlaf, ky); ctx.lineTo(xSchlaf, ky + kh); ctx.stroke();
    ctx.setLineDash([]);
    ctx.fillStyle = '#4FC4E2';
    ctx.textAlign = xSchlaf > BILD_B - 260 ? 'right' : 'left';
    const versatz = ctx.textAlign === 'right' ? -12 : 12;
    ctx.font = `700 24px ${S}`;
    ctx.fillText(tx('bild_schlafenszeit', 'Schlafenszeit'), xSchlaf + versatz, ky + 26);
    ctx.font = `700 24px ${S}`;
    ctx.fillText(`(${uhr})`, xSchlaf + versatz, ky + 54);
    ctx.textAlign = 'left';

    /* Marken an den Hochpunkten.
       Bei vielen Einträgen wird es schnell unleserlich, deshalb bekommen
       nur die vier grössten Sprünge eine Beschriftung. Die übrigen behalten
       ihren Punkt auf der Kurve, aber ohne Text. */
    const beschriftet = (() => {
      // Bei vielen Einträgen liegen die Punkte so dicht, dass jede
      // Beschriftung die nächste überdeckt. Dann sprechen die Punkte für
      // sich, die Liste darunter nennt ohnehin alles.
      if (eintraege.length > 6) return [];
      const wieViele = eintraege.length <= 4 ? eintraege.length : 3;

      const kandidaten = eintraege
        .map((c, i) => ({ i, x: kx + ((c.stunde - 5) / 21) * kb, dosis: mgVon(c.getraenkIndex, c.menge) }))
        .sort((a, b) => b.dosis - a.dosis);

      // Nur aufnehmen, was genug Abstand zu bereits gewählten Labels hat.
      const gewaehlt = [];
      kandidaten.forEach((k) => {
        if (gewaehlt.length >= wieViele) return;
        if (gewaehlt.some(g => Math.abs(g.x - k.x) < 150)) return;
        gewaehlt.push(k);
      });
      return gewaehlt.map(g => g.i);
    })();

    eintraege.forEach((c, i) => {
      const x = kx + ((c.stunde - 5) / 21) * kb;
      const w = mgZurZeit(c.stunde, liste);
      const y = ky + kh - Math.min(1, w / maxWert) * kh;

      ctx.beginPath(); ctx.arc(x, y, 7, 0, Math.PI * 2);
      ctx.fillStyle = '#FFF3E8'; ctx.fill();
      ctx.strokeStyle = '#FF4612'; ctx.lineWidth = 4; ctx.stroke();

      if (!beschriftet.includes(i)) return;

      /* Versatz nach der Zeitreihenfolge, nicht nach der Dosis: Sonst
         landen zwei kurz aufeinander folgende Getränke auf gleicher Höhe.
         Die Klemme sitzt hoch genug, dass die obere Reihe Platz hat. */
      const yText = Math.max(ky + 34, y - (i % 2 === 0 ? 34 : 72));
      ctx.strokeStyle = 'rgba(255,243,232,.45)';
      ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(x, y - 9); ctx.lineTo(x, yText + 8); ctx.stroke();

      ctx.font = `700 22px ${S}`;
      ctx.fillStyle = 'rgba(255,243,232,.92)';
      ctx.textAlign = x > BILD_B - 200 ? 'right' : (x < 200 ? 'left' : 'center');
      ctx.fillText(GETRAENKE[c.getraenkIndex].kurz || GETRAENKE[c.getraenkIndex].name, x, yText);
      ctx.textAlign = 'left';
    });

    // Zeitachse
    ctx.font = `500 22px ${S}`;
    ctx.fillStyle = 'rgba(255,243,232,.55)';
    ctx.fillText('05:00', kx, ky + kh + 34);
    ctx.textAlign = 'center'; ctx.fillText('14:00', kx + kb / 2, ky + kh + 34);
    ctx.textAlign = 'right'; ctx.fillText('02:00', kx + kb, ky + kh + 34);
    ctx.textAlign = 'left';

    /* --- Was getrunken wurde ---
       Der Platz bis zum Farbband ist fest. Passen nicht alle Einträge hinein,
       werden die restlichen in einer Zeile zusammengefasst, statt aus dem
       Bild zu laufen. */
    let y = 852;
    const bandOben = 1080;
    const zeilenHoehe = 42;
    const platz = Math.floor((bandOben - 40 - y - 30) / zeilenHoehe);
    const zeigen = Math.max(1, Math.min(eintraege.length, platz));

    ctx.font = `700 24px ${S}`;
    ctx.fillStyle = '#4FC4E2';
    ctx.letterSpacing = '3px';
    ctx.fillText(tx('bild_mein_tag', 'MEIN TAG'), 80, y);
    ctx.letterSpacing = '0px';
    y += 42;

    eintraege.slice(0, zeigen).forEach((c) => {
      ctx.font = `500 28px ${S}`;
      ctx.fillStyle = 'rgba(255,243,232,.9)';
      ctx.fillText(`${String(c.stunde).padStart(2, '0')}:00 · ${nameVon(c.getraenkIndex, c.menge)}`, 80, y);
      ctx.textAlign = 'right';
      ctx.font = `700 28px ${S}`;
      ctx.fillStyle = '#FF4612';
      ctx.fillText(`${Math.round(mgVon(c.getraenkIndex, c.menge))} mg`, BILD_B - 80, y);
      ctx.textAlign = 'left';
      y += zeilenHoehe;
    });

    const uebrig = eintraege.slice(zeigen);
    if (uebrig.length) {
      const uebrigMg = uebrig.reduce((s, c) => s + mgVon(c.getraenkIndex, c.menge), 0);
      ctx.font = `600 26px ${S}`;
      ctx.fillStyle = 'rgba(255,243,232,.62)';
      ctx.fillText(tx('bild_weitere', 'und {n} weitere', { n: uebrig.length }), 80, y);
      ctx.textAlign = 'right';
      ctx.fillStyle = 'rgba(255,70,18,.85)';
      ctx.fillText(`${Math.round(uebrigMg)} mg`, BILD_B - 80, y);
      ctx.textAlign = 'left';
    }

    /* --- Farbband unten ---
       Das Band reicht bis zur Bildkante, der Text darin bleibt aber
       oberhalb der sicheren Linie, damit er im Profilraster nicht
       abgeschnitten wird. */
    ctx.fillStyle = '#FF4612';
    ctx.fillRect(0, bandOben, BILD_B, BILD_H - bandOben);
    ctx.fillStyle = '#FFF3E8';
    ctx.font = `800 36px ${S}`;
    ctx.fillText(tx('bild_frage_1', 'Und wie viel Koffein nimmst Du'), 80, 1150);
    ctx.fillText(tx('bild_frage_2', 'mit in den Schlaf?'), 80, 1194);
    ctx.font = `600 27px ${S}`;
    ctx.fillStyle = 'rgba(255,243,232,.9)';
    ctx.fillText(ADRESSE, 80, SICHER_UNTEN + 28);

    return flaeche;
  }


  /* --- Dialog zum Teilen ---------------------------------------------------
     Keine der drei Plattformen erlaubt es, über einen Link ein Bild an einen
     Beitrag anzuhängen. Über die Share-URL lässt sich nur Text vorbereiten.
     Es gibt deshalb zwei Wege, und der Dialog nimmt den besseren, der da ist:

       1. Web Share API mit Datei. Auf dem Handy und in Safari geht damit Bild
          und Text in einem Schritt in die App der Wahl.
       2. Zwischenablage. Auf dem Desktop landet das Bild per Klick in der
          Ablage, die Plattform öffnet sich mit vorbereitetem Text, und es
          fehlt nur noch ein Einfügen im Editor.

     Als Rückfalllinie bleibt der Download.                                  */

  const TEILTEXT = tx('teiltext', 'Wie viel Koffein nimmst Du mit in den Schlaf? ' +
                   'Ausgerechnet mit dem Koffeinrechner von Beanwatch.');

  const PLATTFORMEN = [
    {
      schluessel: 'linkedin', name: 'LinkedIn',
      url: 'https://www.linkedin.com/feed/?shareActive=true&text=' +
           encodeURIComponent(TEILTEXT + ' ' + ADRESSE)
    },
    {
      schluessel: 'facebook', name: 'Facebook',
      url: 'https://www.facebook.com/sharer/sharer.php?u=' +
           encodeURIComponent(ADRESSE_URL)
    },
    {
      schluessel: 'instagram', name: 'Instagram',
      url: 'https://www.instagram.com/'
    }
  ];

  function blobVon(flaeche) {
    return new Promise(fertig => flaeche.toBlob(fertig, 'image/png'));
  }

  /** Kann dieses Gerät Bilddateien direkt teilen? */
  function kannNativTeilen() {
    if (typeof navigator.canShare !== 'function') return false;
    try {
      const probe = new File([new Blob([''], { type: 'image/png' })], 'p.png', { type: 'image/png' });
      return navigator.canShare({ files: [probe] });
    } catch (e) {
      return false;
    }
  }

  /** Taste zum Einfügen, wie sie auf diesem Rechner heisst. Mit festen
      Leerzeichen, damit «Strg + V» nicht über zwei Zeilen bricht. */
  function einfuegeTaste() {
    const taste = navigator.platform && /Mac/i.test(navigator.platform) ? 'Cmd + V' : tx('taste_strg', 'Strg + V');
    return taste.replace(/ /g, '\u00a0');
  }

  /** Texte des Teilen-Fensters. Der Nachbau in der Anleitung zeigt dieselben. */
  function teilenTexte() {
    const taste = einfuegeTaste();
    return {
      aria: tx('teilen_aria', 'Ergebnis teilen'),
      schliessen: tx('schliessen', 'Schliessen'),
      eyebrow: tx('teilen_eyebrow', 'Dein Ergebnis'),
      titel: tx('teilen_titel', 'Wohin damit?'),
      bildTeilen: tx('bild_teilen', 'Bild teilen'),
      nativ: tx('nativ_erklaerung', 'Bild und Text gehen zusammen an die App Deiner Wahl.'),
      ablage: tx('ablage_erklaerung', 'Ein Klick legt das Bild in die Zwischenablage und öffnet die Plattform. Dort fügst Du es mit {taste} in den Beitrag ein.', { taste }),
      speichern: tx('speichern_erklaerung', 'Das Bild wird gespeichert und die Plattform öffnet sich. Lade es dort im Beitrag hoch.'),
      nurSpeichern: tx('nur_speichern', 'Nur speichern'),
      inAblage: (plattform) => tx('in_ablage', 'Bild ist in der Zwischenablage. Im Beitrag auf {plattform} mit {taste} einfügen.', { plattform, taste }),
      nurGespeichert: (plattform) => tx('nur_gespeichert', 'Bild gespeichert. Im Beitrag auf {plattform} hochladen.', { plattform }),
      taste
    };
  }

  function teilenDialog(flaeche) {
    const alt = document.getElementById('teilen-dialog');
    if (alt) alt.remove();

    const nativ = kannNativTeilen();
    const ablageGeht = !!(navigator.clipboard && window.ClipboardItem);
    const TT = teilenTexte();

    const dialog = document.createElement('div');
    dialog.id = 'teilen-dialog';
    dialog.className = 'teilen-dialog';
    dialog.innerHTML = `
      <div class="teilen-fenster" role="dialog" aria-modal="true" aria-label="${TT.aria}">
        <button class="teilen-zu" aria-label="${TT.schliessen}">✕</button>
        <span class="eyebrow" style="color:var(--redorange)">${TT.eyebrow}</span>
        <h3 style="margin-top:12px">${TT.titel}</h3>
        <div class="teilen-vorschau"></div>

        ${nativ ? `
          <button class="btn btn--primaer" data-nativ style="width:100%;justify-content:center">
            ${TT.bildTeilen}
          </button>
          <p class="teilen-erklaerung">${TT.nativ}</p>
        ` : `
          <p class="teilen-erklaerung">
            ${ablageGeht ? TT.ablage : TT.speichern}
          </p>
          <div class="teilen-knoepfe">
            ${PLATTFORMEN.map(p => `
              <button class="btn btn--linie" data-plattform="${p.schluessel}">${p.name}</button>
            `).join('')}
          </div>
        `}

        <button class="btn btn--linie" data-speichern style="margin-top:12px;width:100%;justify-content:center">
          ${TT.nurSpeichern}
        </button>
        <p class="teilen-hinweis" role="status"></p>
      </div>`;
    document.body.appendChild(dialog);

    const hinweis = dialog.querySelector('.teilen-hinweis');
    const vorschau = dialog.querySelector('.teilen-vorschau');

    const mini = new Image();
    mini.src = flaeche.toDataURL('image/png');
    mini.alt = tx('vorschau_alt', 'Vorschau des Bildes');
    vorschau.appendChild(mini);

    function speichern() {
      const a = document.createElement('a');
      a.href = flaeche.toDataURL('image/png');
      a.download = 'beanwatch-koffeinrechner.png';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }

    async function inAblage() {
      if (!ablageGeht) return false;
      try {
        const blob = await blobVon(flaeche);
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
        return true;
      } catch (e) {
        return false;
      }
    }

    function schliessen() {
      if (ruhig) { dialog.remove(); return; }
      gsap.to(dialog, { opacity: 0, duration: 0.22, onComplete: () => dialog.remove() });
    }

    dialog.querySelector('.teilen-zu').addEventListener('click', schliessen);
    dialog.addEventListener('click', (e) => { if (e.target === dialog) schliessen(); });

    dialog.querySelector('[data-speichern]').addEventListener('click', () => {
      speichern();
      hinweis.textContent = tx('gespeichert', 'Gespeichert. Du findest es in Deinem Download-Ordner.');
    });

    const nativKnopf = dialog.querySelector('[data-nativ]');
    if (nativKnopf) {
      nativKnopf.addEventListener('click', async () => {
        try {
          const blob = await blobVon(flaeche);
          const datei = new File([blob], 'beanwatch-koffeinrechner.png', { type: 'image/png' });
          await navigator.share({ files: [datei], text: TEILTEXT + ' ' + ADRESSE });
          schliessen();
        } catch (e) {
          if (e && e.name === 'AbortError') return;   // Nutzer hat abgebrochen
          speichern();
          hinweis.textContent = tx('teilen_fehler', 'Teilen ging nicht, das Bild wurde stattdessen gespeichert.');
        }
      });
    }

    dialog.querySelectorAll('[data-plattform]').forEach((knopf) => {
      knopf.addEventListener('click', async () => {
        const p = PLATTFORMEN.find(x => x.schluessel === knopf.dataset.plattform);
        const kopiert = await inAblage();
        if (!kopiert) speichern();

        hinweis.textContent = kopiert ? TT.inAblage(p.name) : TT.nurGespeichert(p.name);

        window.open(p.url, '_blank', 'noopener');
      });
    });

    if (!ruhig) {
      gsap.from(dialog, { opacity: 0, duration: 0.25 });
      gsap.from(dialog.querySelector('.teilen-fenster'),
        { y: 26, scale: 0.97, duration: 0.45, ease: 'bw-aus' });
    }
  }


  /* ======================================================================
     Kaffeewasser
     Eingabe sind die drei Werte, die auf jeder Flaschenetikette und in jedem
     Trinkwasserbericht stehen: Calcium, Magnesium und Hydrogencarbonat.
     Daraus werden Gesamthärte und Karbonathärte gerechnet und im Diagramm
     gegen die Zielbereiche für Filterkaffee und Espresso gestellt.

     Umrechnungsfaktoren (Standard):
       1 °dH Gesamthärte  = 7,14 mg/l Ca  oder  4,34 mg/l Mg
       1 °dH Karbonathärte = 21,8 mg/l HCO₃⁻
       1 °dH              = 17,8 mg/l CaCO₃ (ppm)
     ====================================================================== */

  const F_CA = 7.14, F_MG = 4.34, F_HCO3 = 21.8, F_PPM = 17.8;

  /* Zielbereiche in °dH. Grundlage ist der SCA Water Standard, aufgeteilt
     nach Zubereitung: Filter darf weicher sein, Espresso braucht etwas mehr
     Puffer, auch zum Schutz der Maschine. Es sind Richtbereiche, keine
     Grenzwerte. */
  /* Farbzuordnung wie in der Rösterei: Filterkaffee trägt Redorange,
     Espresso Cyanblau. */
  const ZIELE = {
    filter:   { gh: [2.5, 7.0], kh: [0.5, 3.5], farbe: '#FF4612', name: tx('ziel_filter', 'Filterkaffee') },
    espresso: { gh: [3.5, 8.5], kh: [2.0, 5.0], farbe: '#4FC4E2', name: tx('ziel_espresso', 'Espresso') }
  };

  const ACHSE_MAX = 16;   // °dH auf beiden Achsen, deckt Schweizer Leitungswasser ab

  /* In der Schweiz ist die französische Härte genauso verbreitet wie die
     deutsche. Intern wird durchgehend in °dH gerechnet, nur die Anzeige
     wechselt. 1 °fH = 0,56 °dH */
  const EINHEITEN = {
    dh: { kuerzel: '°dH', faktor: 1,      name: 'Deutsche Härte' },
    fh: { kuerzel: '°fH', faktor: 1.7857, name: 'Französische Härte' }
  };
  let einheit = 'dh';

  function imBereich(wert, spanne) {
    return wert >= spanne[0] && wert <= spanne[1];
  }

  function wasserrechner() {
    const eCa = document.getElementById('wert-calcium');
    const eMg = document.getElementById('wert-magnesium');
    const eHco = document.getElementById('wert-hydrogencarbonat');
    if (!eCa) return;

    const svg = document.getElementById('wasser-diagramm');
    const punkt = svg && svg.querySelector('.eigenes-wasser');
    const punktText = svg && svg.querySelector('.eigenes-wasser-text');

    /* Vorlagen, damit man nicht bei null anfängt. */
    const VORLAGEN = {
      horgen:      { ca: 78,  mg: 12, hco3: 250, name: tx('vorlage_horgen', 'Leitungswasser Horgen') },
      zuerich:     { ca: 45,  mg: 6,  hco3: 140, name: tx('vorlage_zuerich', 'Leitungswasser Zürich') },
      volvic:      { ca: 12,  mg: 8,  hco3: 71,  name: 'Volvic' },
      evian:       { ca: 80,  mg: 26, hco3: 360, name: 'Evian' },
      lauretana:   { ca: 1,   mg: 0.3, hco3: 4,  name: 'Lauretana' },
      valser:      { ca: 420, mg: 62, hco3: 385, name: 'Valser' }
    };

    function rechne() {
      const ca = Math.max(0, +eCa.value || 0);
      const mg = Math.max(0, +eMg.value || 0);
      const hco3 = Math.max(0, +eHco.value || 0);

      const gh = ca / F_CA + mg / F_MG;
      const kh = hco3 / F_HCO3;

      // Werte in der gewählten Einheit anzeigen
      const E = EINHEITEN[einheit];
      document.getElementById('anzeige-gh').textContent =
        zahl1(gh * E.faktor) + ' ' + E.kuerzel;
      document.getElementById('anzeige-kh').textContent =
        zahl1(kh * E.faktor) + ' ' + E.kuerzel;
      document.getElementById('anzeige-ppm').textContent = Math.round(gh * F_PPM) + ' ppm';

      // Punkt im Diagramm setzen
      if (punkt) {
        const x = 60 + Math.min(kh, ACHSE_MAX) / ACHSE_MAX * 380;
        const y = 300 - Math.min(gh, ACHSE_MAX) / ACHSE_MAX * 260;
        if (ruhig) { punkt.setAttribute('cx', x); punkt.setAttribute('cy', y); }
        else gsap.to(punkt, { attr: { cx: x, cy: y }, duration: 0.6, ease: 'bw-aus', overwrite: true });
        if (punktText) {
          punktText.setAttribute('x', Math.min(x + 12, 400));
          punktText.setAttribute('y', y - 10);
        }
      }

      // Bewertung je Zubereitung
      const treffer = {};
      Object.keys(ZIELE).forEach((k) => {
        const z = ZIELE[k];
        treffer[k] = imBereich(gh, z.gh) && imBereich(kh, z.kh);
        const marke = document.getElementById('treffer-' + k);
        if (marke) {
          marke.textContent = treffer[k] ? tx('im_zielbereich', 'Im Zielbereich') : tx('ausserhalb', 'Ausserhalb');
          marke.className = 'pill' + (treffer[k] ? ' pill--gefuellt' : '');
          // Keine eigene Farbe setzen: Die Pille steht auf dem dunkelblauen
          // Ergebnisfeld und erbt von dort Hellorange. Ein fest gesetztes
          // Dunkelblau war auf diesem Grund unsichtbar.
        }
      });

      // Urteil in Worten
      const urteil = document.getElementById('wasser-urteil');
      const rat = document.getElementById('wasser-rat');
      if (!urteil) return;

      if (treffer.filter && treffer.espresso) {
        urteil.innerHTML = tx('wasser_urteil_beides', 'Dieses Wasser passt für <strong>beides</strong>. Filterkaffee und Espresso liegen im Zielbereich.');
        rat.textContent = tx('wasser_rat_beides', 'Nichts zu tun. Wenn Du eine Espressomaschine hast, entkalke sie trotzdem im üblichen Rhythmus.');
      } else if (treffer.filter) {
        urteil.innerHTML = tx('wasser_urteil_filter', 'Gut für <strong>Filterkaffee</strong>. Für Espresso ist es etwas zu weich.');
        rat.textContent = tx('wasser_rat_filter', 'Für die Espressomaschine wäre etwas mehr Karbonathärte besser, sonst kann der Espresso dünn und spitz wirken.');
      } else if (treffer.espresso) {
        urteil.innerHTML = tx('wasser_urteil_espresso', 'Gut für <strong>Espresso</strong>. Für hellen Filterkaffee ist es einen Tick zu hart.');
        rat.textContent = tx('wasser_rat_espresso', 'Für Pour Over lohnt sich ein Tischwasserfilter, dann kommen die Fruchtnoten klarer durch.');
      } else if (kh > 5) {
        urteil.innerHTML = tx('wasser_urteil_kh_hoch', 'Die <strong>Karbonathärte ist zu hoch</strong>. Sie puffert die Säuren weg, der Kaffee schmeckt flach.');
        rat.textContent = tx('wasser_rat_kh_hoch', 'Ein Wasserfilter mit Ionenaustauscher senkt gezielt die Karbonathärte. Für die Espressomaschine ist er hier praktisch Pflicht.');
      } else if (gh < 2) {
        urteil.innerHTML = tx('wasser_urteil_mineralarm', 'Sehr <strong>mineralarm</strong>. Ohne Mineralien fehlt dem Kaffee der Körper.');
        rat.textContent = tx('wasser_rat_mineralarm', 'Destilliertes oder sehr weiches Wasser ergibt dünnen, oft sauren Kaffee. Hier hilft Aufmineralisieren, etwa mit Mineralkonzentrat.');
      } else {
        urteil.innerHTML = tx('wasser_urteil_sonst', 'Ausserhalb der beiden Zielbereiche, aber <strong>nicht dramatisch</strong>.');
        rat.textContent = tx('wasser_rat_sonst', 'Probier es einfach aus. Wenn der Kaffee flach schmeckt, liegt es meist an zu hoher Karbonathärte.');
      }
    }

    [eCa, eMg, eHco].forEach(el => el.addEventListener('input', rechne));

    const vorlage = document.getElementById('wasser-vorlage');
    if (vorlage) {
      vorlage.innerHTML = '<option value="">' + tx('eigene_werte', 'Eigene Werte eingeben') + '</option>' +
        Object.keys(VORLAGEN).map(k => `<option value="${k}">${VORLAGEN[k].name}</option>`).join('');

      vorlage.addEventListener('change', () => {
        const v = VORLAGEN[vorlage.value];
        if (!v) return;
        eCa.value = v.ca; eMg.value = v.mg; eHco.value = v.hco3;
        rechne();
      });
    }

    /* Achsenbeschriftung wird gezeichnet, nicht fest im Markup gesetzt,
       damit sie beim Wechsel auf französische Härte mitwandert. */
    function achsenZeichnen() {
      if (!svg) return;
      const E = EINHEITEN[einheit];
      const schritte = einheit === 'fh' ? [0, 5, 10, 15, 20, 25] : [0, 2, 4, 6, 8, 10, 12, 14, 16];

      const x = svg.querySelector('#achse-x');
      const y = svg.querySelector('#achse-y');
      const raster = svg.querySelector('#raster');

      const alsDh = (w) => w / E.faktor;   // Anzeigewert zurück in °dH

      if (x) {
        x.innerHTML = schritte
          .filter(w => alsDh(w) <= ACHSE_MAX)
          .map(w => `<text x="${(60 + alsDh(w) / ACHSE_MAX * 380).toFixed(1)}" y="320">${w}</text>`)
          .join('');
      }
      if (y) {
        y.innerHTML = schritte
          .filter(w => alsDh(w) <= ACHSE_MAX)
          .map(w => `<text x="50" y="${(304 - alsDh(w) / ACHSE_MAX * 260).toFixed(1)}">${w}</text>`)
          .join('');
      }
      if (raster) {
        raster.innerHTML = schritte
          .filter(w => alsDh(w) <= ACHSE_MAX)
          .map((w) => {
            const px = (60 + alsDh(w) / ACHSE_MAX * 380).toFixed(1);
            const py = (300 - alsDh(w) / ACHSE_MAX * 260).toFixed(1);
            return `<line x1="60" y1="${py}" x2="440" y2="${py}"/>` +
                   `<line x1="${px}" y1="40" x2="${px}" y2="300"/>`;
          }).join('');
      }

      const xt = svg.querySelector('#achse-x-titel');
      const yt = svg.querySelector('#achse-y-titel');
      if (xt) xt.textContent = tx('achse_kh', 'Karbonathärte KH in {einheit}', { einheit: E.kuerzel });
      if (yt) yt.textContent = tx('achse_gh', 'Gesamthärte GH in {einheit}', { einheit: E.kuerzel });
    }

    const einheitWahl = document.getElementById('haerte-einheit');
    if (einheitWahl) {
      einheitWahl.addEventListener('change', () => {
        einheit = einheitWahl.value;
        achsenZeichnen();
        rechne();
      });
    }

    achsenZeichnen();

    // Zielbereiche als Rechtecke ins Diagramm zeichnen
    if (svg) {
      const gruppe = svg.querySelector('.zielbereiche');
      if (gruppe) {
        gruppe.innerHTML = Object.keys(ZIELE).map((k) => {
          const z = ZIELE[k];
          const x = 60 + z.kh[0] / ACHSE_MAX * 380;
          const b = (z.kh[1] - z.kh[0]) / ACHSE_MAX * 380;
          const y = 300 - z.gh[1] / ACHSE_MAX * 260;
          const h = (z.gh[1] - z.gh[0]) / ACHSE_MAX * 260;
          return `<rect x="${x}" y="${y}" width="${b}" height="${h}" rx="6"
                        fill="${z.farbe}" opacity=".18" stroke="${z.farbe}"
                        stroke-width="2" stroke-dasharray="5 4"/>
                  <text x="${x + 7}" y="${y + 19}" fill="${z.farbe}"
                        style="font:700 13px Gabarito,sans-serif">${z.name}</text>`;
        }).join('');
      }
    }

    rechne();
  }

  /* ======================================================================
     Brüh-Timer
     Läuft über eine GSAP-Timeline statt über setInterval, damit er
     denselben Ticker nutzt wie alles andere und beim Pausieren sauber steht.
     ====================================================================== */
  /* Der Abschlusstext hing fest am Filterkaffee. Espresso-Guides brauchen
     einen eigenen, deshalb als zweites Argument überschreibbar. */
  const TIMER_ENDE = tx('timer_ende', 'Trichter abnehmen, umrühren, probieren. Wie ist es geworden?');

  // Ein Zähler ohne GSAP, mit den Griffen, die der Timer braucht (play,
  // pause, progress, restart). Fehlt GSAP, läuft der Timer trotzdem: Er
  // ist ein Werkzeug und keine Zierde.
  function zaehler(stand, schluessel, dauer, beiBild, amEnde) {
    let ab = 0, bei = 0, id = 0;
    const bild = (t) => {
      stand[schluessel] = Math.min(dauer, bei + Math.max(0, t - ab) / 1000);
      beiBild();
      if (stand[schluessel] >= dauer) { id = 0; bei = dauer; amEnde(); return; }
      id = requestAnimationFrame(bild);
    };
    const halt = () => { if (id) { cancelAnimationFrame(id); id = 0; bei = stand[schluessel]; } };
    return {
      progress: () => (id ? stand[schluessel] : bei) / dauer,
      play() { if (id || bei >= dauer) return; ab = performance.now(); id = requestAnimationFrame(bild); },
      pause(zeit) { halt(); if (zeit !== undefined) { bei = zeit; stand[schluessel] = zeit; } },
      restart() { halt(); bei = 0; stand[schluessel] = 0; this.play(); }
    };
  }

  function brewTimer(phasen, schlusstext) {
    const uhr = document.getElementById('timer-uhr');
    const phase = document.getElementById('timer-phase');
    const anweisung = document.getElementById('timer-anweisung');
    const fuellung = document.querySelector('#timer-spur .fuellung');
    const start = document.getElementById('timer-start');
    const zurueck = document.getElementById('timer-zurueck');
    if (!uhr || !phasen || !phasen.length) return;

    const gesamt = phasen[phasen.length - 1].bis;
    const stand = { s: 0 };
    let laeuft = false;

    function zeige(sekunden) {
      const m = Math.floor(sekunden / 60);
      const s = Math.floor(sekunden % 60);
      uhr.textContent = `${m}:${String(s).padStart(2, '0')}`;

      const aktuell = phasen.find(p => sekunden < p.bis) || phasen[phasen.length - 1];
      phase.textContent = aktuell.name;
      anweisung.textContent = aktuell.text;
      if (fuellung) fuellung.style.transform = `scaleX(${sekunden / gesamt})`;
    }

    const fertig = () => {
      laeuft = false;
      start.textContent = tx('timer_nochmal', 'Nochmal');
      phase.textContent = tx('timer_fertig', 'Fertig');
      anweisung.textContent = schlusstext || TIMER_ENDE;
    };
    const tl = window.gsap
      ? gsap.to(stand, {
        s: gesamt,
        duration: gesamt,
        ease: 'none',
        paused: true,
        onUpdate: () => zeige(stand.s),
        onComplete: fertig
      })
      : zaehler(stand, 's', gesamt, () => zeige(stand.s), fertig);

    start.addEventListener('click', () => {
      if (tl.progress() === 1) {
        tl.restart(); tl.pause(); stand.s = 0; zeige(0);
      }
      laeuft = !laeuft;
      if (laeuft) { tl.play(); start.textContent = tx('timer_pause', 'Pause'); }
      else { tl.pause(); start.textContent = tx('timer_weiter', 'Weiter'); }
    });

    zurueck.addEventListener('click', () => {
      tl.pause(0);
      stand.s = 0;
      laeuft = false;
      start.textContent = tx('timer_start', 'Start');
      zeige(0);
    });

    zeige(0);
  }

  return { koffeinrechner, wasserrechner, brewTimer, GETRAENKE, ZIELE, mgVon };
})();
